import React, { useState, useEffect } from 'react';
import {
    Plus, Eye, Send, MapPin, User, Calendar, IndianRupee, Globe, Filter, ChevronDown, ChevronUp, FileText, X, Users, no_of_home, TreePine, Edit, Save, Check, Trash2, ArrowLeft, Download,
    Layers,
    ZoomIn, ZoomOut, ChevronLeft, ChevronRight,
    Building,
    Info,
    CreditCard,
    Percent,
    Shield, DollarSign, Upload, Image, FileType
} from 'lucide-react';

import AddOwner from '../jmr/RailwayAddOwner';
import EditOwner from '../jmr/RailwayEditOwner';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import apiService from '../../config';
import Section19 from '../../Pages/Section19';
import { useLanguage } from "../../StoreContext/LanguageContext";
import { toast } from 'react-toastify';
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';
const RailwayJointMesurmentList = ({ onFileChange, landAcquisitionId, setSelectedComponent, onBack, initialMeasurementData = null,
    onDataUpdate = null, setSubComponent, }) => {
    // console.log('><<><><><><>', localStorage.selectedProposal);
    const [isEditing, setIsEditing] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [showconfirm, setShowConfirm] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ title: '', message: '', type: 'success' });
    const { language, translations } = useLanguage();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [measurementId, setMeasurementId] = useState(null);
    const [measurementData, setMeasurementData] = useState(null);
    const [landAcquisitionData, setLandAcquisitionData] = useState(null);
    const [ownersData, setOwnersData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [selectedOwnerData, setSelectedOwnerData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightSummary, setHighlightSummary] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [existingFiles, setExistingFiles] = useState([]);
    const [viewMode, setViewMode] = useState('list');
    const [selectedFilePreview, setSelectedFilePreview] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [viewedOwner, setViewedOwner] = useState(null);
    const [showImageViewer, setShowImageViewer] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [owners, setOwners] = useState([]);
    const [landAcquisition, setLandAcquisition] = useState(null);
    const [selectedOwnerIndex, setSelectedOwnerIndex] = useState(0);
    const [selectedOwnerInDetails, setSelectedOwnerInDetails] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [solatiumPercentage, setSolatiumPercentage] = useState(30);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const [showAddOwner, setShowAddOwner] = useState(false);
    const [showEditOwner, setShowEditOwner] = useState(false);
    const [surveyorButtonDisabled, setSurveyorButtonDisabled] = useState(false);
    const [dlsrButtonDisabled, setDslrButtonDisabled] = useState(false);
    const [laoButtonDisabled, setLaoButtonDisabled] = useState(false);
    const [agencyButtonDisabled, setAgencyButtonDisabled] = useState(false);

    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [uploadedFileNames, setUploadedFileNames] = useState([]);
    const [measurements, setMeasurements] = useState([]);
    const [hasFirstSentToLAO, setHasFirstSentToLAO] = useState(false);
    const [hasFirstSentToSurveyor, setHasFirstSentToSurveyor] = useState(false);
    const [hasFirstSentToDSLR, setHasFirstSentToDSLR] = useState(false);
    const [hasFirstSentToAgency, setHasFirstSentToAgency] = useState(false);
    const [onConfirmAction, setOnConfirmAction] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showSendToAgencyModal, setShowSendToAgencyModal] = useState(false);
    const [sendingToAgency, setSendingToAgency] = useState(false);
    const [showSection19, setShowSection19] = useState(false);
    const [showSection19Modal, setShowSection19Modal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [documentUrl, setDocumentUrl] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [showSendbackToSLrModal, setShowSendbackToSLrModal] = useState(false);
    const [filterMode, setFilterMode] = useState('all');
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [showRoleModal, setShowRoleModal] = useState(false);
    const [roleFormData, setRoleFormData] = useState({});
    const [roleFile, setRoleFile] = useState(null);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [showSendToSLRModal, setShowSendToSLRModal] = useState(false);
    const [showSendToSurveyorModal, setShowSendToSurveyorModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [agricultureUsers, setAgricultureUsers] = useState([]);
    const [tpUsers, setTpUsers] = useState([]);
    const [forestUsers, setForestUsers] = useState([]);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [proposalId, setProposalId] = useState(null);
    const [remarks, setRemarks] = useState('Approved');
    const [justification, setJustification] = useState();
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [showSendBackToLAOModal, setShowSendBackToLAOModal] = useState(false);
    const [showSendBackToDSLRModal, setShowSendBackToDSLRModal] = useState(false);
    const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
    const [districts, setDistricts] = useState([]);
    const [talukas, setTalukas] = useState([]);
    const [villages, setVillages] = useState([]);
    const [loadingMeasurements, setLoadingMeasurements] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingTalukas, setLoadingTalukas] = useState(false);
    const [loadingVillages, setLoadingVillages] = useState(false);
    const canShowData = filterMode === 'all' || (filterMode === 'location' && hasValidLocationSelection);
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [selectedVillage, setSelectedVillage] = useState('');
    const [proposalData, setProposalData] = useState(null);
    const [showSurveyorConfirmModal, setShowSurveyorConfirmModal] = useState(false);
    const [hasSentBackToSLR, setHasSentBackToSLR] = useState(false);
    const hasValidLocationSelection = selectedDistrict;
    const [selectedLandAcquisitionId, setSelectedLandAcquisitionId] = useState(null);
    const [selectedMeasurement, setSelectedMeasurement] = useState(null);
    const [hasSentToSurveyor, setHasSentToSurveyor] = useState(false);
    const [hasAssignedToSurveyor, setHasAssignedToSurveyor] = useState(false);
    const [showLandSelectionModal, setShowLandSelectionModal] = useState(false);
    const [selectedLandRecord, setSelectedLandRecord] = useState(null);
    const [confirmConfig, setConfirmConfig] = useState({ title: '', message: '', onConfirm: null, onCancel: null, type: 'warning' });
    const [proposalDetails, setProposalDetails] = useState(null);
    // Digital signature
    const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const [currentEditData, setCurrentEditData] = useState({});
    const [verifiedRows, setVerifiedRows] = useState(new Set());


    const [selectedUsers, setSelectedUsers] = useState({
        agriculture: '',
        tp: '',
        forest: ''
    });
    const [selectedDocuments, setSelectedDocuments] = useState({
        agriculture: null,
        forest: null,
        tp: null
    });
    const [signedDocuments, setSignedDocuments] = useState({
        agriculture: null,
        forest: null,
        tp: null
    });
    const [currentSigningAgency, setCurrentSigningAgency] = useState(null);
    const [newOwner, setNewOwner] = useState({
        actual_occupant: '', contact_number: '', email: '', owner_type: '',
        owner_address: '', aadhaar_number: '', pan_number: '', bank_name: '',
        branch_name: '', account_number: '', ifsc_code: '', account_holder_name: '',
        survey_no: '', land_area: '', land_category: '', land_use: '', land_value_rate: '',
        no_of_structure: '', no_of_tree: '', no_of_water_body: '', no_of_other_asset: '', no_of_crop: '',
        nature_of_owner: '', justification: '', owner_7_12_non_irrigable_area: '',
        owner_7_12_irrigable_area: '', owner_irrigable_area: '', owner_non_irrigable_area: '',

    });

    const [buttonStatus, setButtonStatus] = useState({
        sendBackToLAO: false,
        assignSurveyor: false
    });

    const [editFormData, setEditFormData] = useState({
        project_id: '',
        village_id: '',
        survey_no: '',
        owner_aqr_area: '',
        area_unit_id: 'ACRE',
        landholder_name: '',
        survey_type: 'Revenue',
        irrigable_type: '',
        irrigable_area: '',
        non_irrigable_area: '',
        owner_total_area: '',
        owner_aqr_area: '',
        akoom: '',
        dist_no: '',
        tehsil_no: '',
        // Add new editable fields
        no_of_tree: '',
        latitude: '',
        longitude: '',
        no_of_home: '',
        no_of_other_asset: '',
        no_of_water_body: '',
        no_of_borewell: '',
        no_of_pipeline: '',
        no_of_wirefencing: '',
        no_of_tinshed: '',
        remarks: '',
        justification: '',
        // Owner details
        actual_occupant: '',
        nature_of_owner: '',
        owner_type: '',
        owner_contact: '',
        owner_email: '',
        owner_address: '',
        bank_name: '',
        branch_name: '',
        account_number: '',
        ifsc_code: '',
        account_holder_name: '',
        aadhaar_number: '',
        pan_number: '',
        owner_7_12_non_irrigable_area: '',
        owner_7_12_irrigable_area: '',
        owner_irrigable_area: '',
        owner_non_irrigable_area: ''
    });
    const getDocumentToUpload = (agency) => {
        return signedDocuments[agency] || selectedDocuments[agency];
    };
    const hasValidSelection = () => {
        return (
            (selectedUsers.agriculture && selectedDocuments.agriculture) ||
            (selectedUsers.forest && selectedDocuments.forest) ||
            (selectedUsers.tp && selectedDocuments.tp)
        );
    };
    const handleSignatureSuccess = (signedDocument) => {
        if (currentSigningAgency) {
            setSignedDocuments(prev => ({
                ...prev,
                [currentSigningAgency]: signedDocument
            }));
            setShowSignaturePad(false);
            setCurrentSigningAgency(null);
            toast.success(`Document signed successfully for ${currentSigningAgency}`);
        }
    };
    // localostorage.selectedProposal 
    useEffect(() => {
        try {
            const stored = localStorage.getItem("selectedProposal");
            if (stored) {
                setProposalDetails(JSON.parse(stored));
            }
        } catch (e) {
            console.error("Error parsing selectedProposal:", e);
        }
    }, []);

    useEffect(() => {
        fetchButtonStatus();
    }, [currentProjectId, proposalId]);

    // today's date
    const todayStr = new Date().toLocaleDateString("mr-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });

    // ADD THESE HELPER FUNCTIONS HERE:
    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);

        // Don't auto-hide success messages so user can see them
        if (type !== 'success') {
            setTimeout(() => setShowAlertModal(false), 5000);
        }
    };

    useEffect(() => {
        const storedMeasurementData = localStorage.getItem('selectedMeasurementData');

        if (storedMeasurementData) {
            try {
                const measurement = JSON.parse(storedMeasurementData);
                console.log('ViewMeasurementList received measurement:', measurement);

                if (measurement.owners && measurement.landAcquisition) {
                    if (measurement.measurementId) {
                        setMeasurementId(measurement.measurementId);
                    }
                    setOwners(measurement.owners);
                    setLandAcquisition(measurement.landAcquisition);

                    // Set form data from landAcquisition - Updated mapping
                    setEditFormData({
                        project_id: measurement.landAcquisition.project_id,
                        village_id: measurement.landAcquisition.village_id,
                        survey_no: measurement.landAcquisition.land_survey_no || '',
                        aqr_area: parseFloat(measurement.landAcquisition.aqr_area) || 0,
                        area_unit_id: measurement.landAcquisition.area_unit_id || 'ACRE',
                        landholder_name: measurement.landAcquisition.landholder_name || '',
                        survey_type: measurement.landAcquisition.survey_type || 'Revenue',
                        irrigable_type: measurement.landAcquisition.irrigable_type || '',
                        irrigable_area: measurement.landAcquisition.irrigable_area || '',
                        non_irrigable_area: measurement.landAcquisition.non_irrigable_area || '',
                        total_area: measurement.landAcquisition.total_area || '',
                        // is_active: measurement.landAcquisition.is_active ?? 1,
                        // land_no: measurement.landAcquisition.land_no || '',
                        dist_no: measurement.landAcquisition.dist_no || '',
                        tehsil_no: measurement.landAcquisition.tehsil_no || ''
                    });

                    if (measurement.owners.length > 0) {
                        setSelectedOwnerInDetails(measurement.owners[0]);
                    }
                }
            } catch (error) {
                console.error('Error parsing stored measurement data:', error);
            }
        }
    }, []);

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    const USER_ROLES = {
        SURVEYOR: 7,
        LAO: 3,
        DSLR: 15,
        AGENCY: 21,
        DATA_ENTRY: 14
    };

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    const [identityProofs, setIdentityProofs] = useState({
        aadhaarNumber: '',
        panNumber: '',
        documents: []
    });

    useEffect(() => {
        const getProjectInfo = () => {
            const userData = localStorage.getItem("userData");
            let proposalFromUser = null;

            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    proposalFromUser = user.default_proposal || user.data?.default_proposal || null;
                } catch (e) {
                    console.error("Error parsing user data for proposal ID:", e);
                }
            }

            if (proposalFromUser) {
                setProposalId(proposalFromUser);
                // localStorage.setItem("currentProposalId", proposalFromUser); // overwrite
            }

            // 🔹 Project info
            const currentProjectData = localStorage.getItem("currentProjectData");
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name,
                    };
                } catch (e) {
                    console.error("Error parsing current project data:", e);
                }
            }

            const selectedProject = localStorage.getItem("selectedProject");
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name,
                    };
                } catch (e) {
                    console.error("Error parsing selected project:", e);
                }
            }

            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return {
                        id: user.data?.project_id || user.project_id,
                        name: user.data?.project_name || user.project_name,
                    };
                } catch (e) {
                    console.error("Error parsing user data:", e);
                }
            }

            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
        setCurrentProjectName(projectInfo.name);
    }, []);

    useEffect(() => {
        if (currentProjectId && proposalId) {
            console.log("✅ Ready with project_id:", currentProjectId, "proposal_id:", proposalId);
        }
    }, [currentProjectId, proposalId]);

    useEffect(() => {
        fetchMeasurementData();
    }, [currentProjectId, proposalId]);

    const handleSection21_1 = () => {
        console.log("Switching to Section21_1");
        setSubComponent('Section21_1');
    };

    const handleSection21_1_4 = () => {
        console.log("Switching to Section21_1_4");
        setSubComponent('Section21_1_4');
    };

    const handleDistrictChange = (e) => {
        const selectedDistrictId = e.target.value;
        setSelectedDistrict(selectedDistrictId);
        setSelectedTaluka('');
        setSelectedVillage('');
        setTalukas([]);
        setVillages([]);
    };

    const handleTalukaChange = (e) => {
        const selectedTalukaId = e.target.value;
        setSelectedTaluka(selectedTalukaId);
        setSelectedVillage('');
        setVillages([]);
        // Don't clear measurements here - let the useEffect handle it
    };

    const handleVillageChange = (e) => {
        const selectedVillageId = e.target.value;
        console.log('Village changed to:', selectedVillageId);
        setSelectedVillage(selectedVillageId);
        // Don't clear measurements here - let the useEffect handle it
    };
    // ---------------------------
    const sumField = (arr, fieldPath) => {
        if (!arr || !Array.isArray(arr)) return 0;
        return arr.reduce((sum, item) => {
            // support nested path like 'owner.aqr_area' if needed
            const value = fieldPath.split('.').reduce((o, k) => (o ? o[k] : undefined), item);
            const n = Number(value ?? 0);
            return sum + (isNaN(n) ? 0 : n);
        }, 0);
    };

    const totals = {
        // भूमापन अभिलेखानुसार (landAcquisitionData)
        bhumapan_aqr: sumField(landAcquisitionData, 'aqr_area'),                // लागवडयोग्य क्षेत्र
        bhumapan_pot: sumField(landAcquisitionData, 'non_irrigable_area'),     // पोट खराब क्षेत्र (or your key)
        bhumapan_total: sumField(landAcquisitionData, 'total_area'),           // एकूण क्षेत्र

        // प्रस्तावानुसार संपादनाखालील (landAcquisitionData) -- replace keys if different
        prastaav_dharan: sumField(landAcquisitionData, 'aqr_area'),           // धारण केलेले क्षेत्र (example uses aqr_area)
        prastaav_estimated: sumField(landAcquisitionData, 'estimated_aqr_area'), // संपादनाखालील अंदाजे क्षेत्र (if exists)

        // प्रत्यक्ष मोजणीअंती संपादनाखालील (ownersData)
        actual_aqr: sumField(ownersData, 'owner_irrigable_area'),             // लागवडयोग्य क्षेत्र (owner-level)
        actual_pot: sumField(ownersData, 'owner_non_irrigable_area'),        // पोट खराब क्षेत्र (owner-level)
        actual_total: sumField(ownersData, 'owner_total_area'),             // संपादनाखालील एकूण क्षेत्र (owner-level)
    };

    // Format helper (two decimals)
    const fmt = (n) => Number(n || 0).toFixed(2);

    // Add these helper functions BEFORE fetchMeasurementData
    const handleRowVerification = (ownerId) => {
        setVerifiedRows(prev => {
            const newSet = new Set(prev);
            if (newSet.has(ownerId)) {
                newSet.delete(ownerId);
            } else {
                newSet.add(ownerId);
            }
            return newSet;
        });
    };

    // Check if all active rows are verified
    const areAllRowsVerified = () => {
        const activeOwners = landAcquisitionData?.flatMap(land =>
            (land.owners || []).filter(owner => Number(owner.is_active) === 1)
        ) || [];

        return activeOwners.length > 0 &&
            activeOwners.every(owner => verifiedRows.has(owner.land_owner_id));
    };

    const fetchMeasurementData = async () => {
        console.log("fetchMeasurementData called with:", { currentProjectId, proposalId });

        if (!currentProjectId && !proposalId) {
            console.log("No projectId or proposalId provided, returning early");
            return;
        }

        setLoadingMeasurements(true);
        console.log("Starting API call...");
        setLoading(true);   // show loader

        try {
            const result = await apiService.getAllRailwayOwner(
                null, null, null,
                currentProjectId,
                proposalId
            );

            console.log("API Response received:", result);

            if (result.data && result.data.length > 0) {

                // Set land acquisition data
                setLandAcquisitionData(result.data);

                console.log("Data set successfully:",
                    result.data);
                fetchButtonStatus();
            } else {
                setLandAcquisitionData(null);
            }
        } catch (error) {
            console.error('Error in fetchMeasurementData:', error);
            setOwnersData([]);
        } finally {
            setLoadingMeasurements(false);
            setLoading(false); // hide loader after completion
        }
    };

    const confirmPartialVerification = (verifiedCount, totalCount, actionCallback) => {
        if (verifiedCount < totalCount) {
            setOnConfirmAction(() => actionCallback);
            setShowConfirmationModal(true);
        } else {
            actionCallback();
        }
    };

    const getCurrentLocationDescription = () => {
        if (filterMode === 'all') {
            return 'All Locations';
        }

        if (selectedDistrict && selectedTaluka && selectedVillage) {
            return `Village: ${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}`;
        } else if (selectedDistrict && selectedTaluka) {
            return `Taluka: ${selectedTaluka}, ${selectedDistrict}`;
        } else if (selectedDistrict) {
            return `District: ${selectedDistrict}`;
        } else {
            return 'No location selected';
        }
    };

    const getVerifiedLandAcquisitionIds = (measurements, userRole) => {
        let targetMeasurements = [];

        if (userRole === USER_ROLES.DSLR) {
            // For DSLR, get measurements that are SLR verified (to send back to LAO)
            targetMeasurements = measurements.filter(m => m.is_SLRVerified === true);
        } else if (userRole === USER_ROLES.SURVEYOR) {
            // For Surveyor, get measurements that are surveyor verified (to send back to DSLR)
            targetMeasurements = measurements.filter(m => m.is_surveyorVerified === true);
        }

        const targetIds = landAcquisitionData
            .map(item => item.LandAcquisition_id)
            .filter(id => id !== null && id !== undefined && id !== '') // Remove null/undefined/empty values
            .filter((id, index, array) => array.indexOf(id) === index); // Remove duplicates

        return targetIds.join(',');
    };

    // Add this state declaration with your other useState calls:
    const [userRole, setUserRole] = useState(() => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                return user.user_role || null;
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
        }
        return null;
    });
    const handleViewDetails = (measurement) => {
        const landAcquisitionId = measurement?.LandAcquisition_id || measurement?.id;
        setSelectedLandAcquisitionId(landAcquisitionId);

        if (!landAcquisitionId) {
            showAlert('Land Acquisition ID not found');
            return;
        }

        // Store the measurement data for reference
        setSelectedMeasurement(measurement);

        setSubComponent('ViewMeasurementList', landAcquisitionId);
    };

    const handleSurveyorVerification = async (unassignedLandAcquisitionIds) => {
        try {
            setLoading(true);
            console.log("----------------------------------3");

            const verificationPayload = {
                is_surveyorVerified: true
            };
            console.log("----------------------------------4");

            // Split incoming string into array of IDs
            const ids = unassignedLandAcquisitionIds.split(',').map(id => id.trim());
            console.log("----------------------------------1");

            for (const landId of ids) {
                console.log('Completing measurement with ID:', landId);

                const response = await apiService.patchRailwayUpdateLand(
                    landId, // use the current ID
                    verificationPayload,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                if (response?.status === 200) {
                    // Update state for each successful update
                    // setMeasurements(prevMeasurements =>
                    //     prevMeasurements.map(m =>
                    //         m.LandAcquisition_id.toString() === landId
                    //             ? { ...m, is_surveyorVerified: true }
                    //             : m
                    //     )
                    // );
                } else {
                    toast.error(`Failed to complete measurement for ID ${landId}`, {
                        duration: 4000,
                        position: 'top-right',
                    });
                }
            }

            toast.success('All selected measurements verified successfully!', {
                duration: 4000,
                position: 'top-right',
            });

        } catch (error) {
            console.error('Error completing measurement:', error);

            let errorMessage = 'Error occurred while completing measurement';
            if (error.response) {
                errorMessage += `: ${error.response.data?.message || error.response.statusText}`;
            } else if (error.message) {
                errorMessage += `: ${error.message}`;
            }

            toast.error(errorMessage, {
                duration: 4000,
                position: 'top-right',
            });
        } finally {
            setLoading(false);
        }
    };


    const handleVerification = async (measurement) => {
        try {
            setLoading(true);

            let verificationPayload;
            if (userRole === USER_ROLES.SURVEYOR) {
                verificationPayload = { is_surveyorVerified: true };
            } else if (userRole === USER_ROLES.DSLR) {
                verificationPayload = { is_SLRVerified: true };

            }

            // ✅ Normalize measurement into array of IDs
            let ids = [];
            if (Array.isArray(measurement)) {
                ids = measurement.map(m => m.LandAcquisition_id || m).filter(Boolean);
            } else if (typeof measurement === "string") {
                ids = measurement
                    .split(",")              // split by comma
                    .map(id => id.trim())    // trim spaces
                    .filter(id => id !== ""); // 🚀 remove empty strings from ",,"
            } else if (measurement?.LandAcquisition_id) {
                ids = [measurement.LandAcquisition_id];
            }

            if (ids.length === 0) {
                console.warn("No valid LandAcquisition_id found in:", measurement);
                return;
            }

            console.log("Verifying measurements with IDs:", ids);

            // ✅ Call API for each ID in parallel
            const responses = await Promise.all(
                ids.map(id =>
                    apiService.patchRailwayUpdateLand(id, verificationPayload, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                )
            );

            // ✅ Check all responses
            if (responses.every(res => res?.status === 200)) {
                console.log("All measurements Updated successfully:", ids);
            } else {
                toast.error("Some measurements failed to verify.", {
                    duration: 4000,
                    position: "top-right",
                });
            }

        } catch (error) {
            console.error("Error verifying measurement(s):", error);

            let errorMessage = "Error occurred while verifying measurement(s)";
            if (error.response) {
                errorMessage += `: ${error.response.data?.message || error.response.statusText}`;
            } else if (error.message) {
                errorMessage += `: ${error.message}`;
            }

            toast.error(errorMessage, {
                duration: 4000,
                position: "top-right",
            });
        } finally {
            setLoading(false);
        }
    };


    // 🔧 Auto-load users & seed today’s date when Role Pre-Modal opens
    useEffect(() => {
        if (!showRoleModal) return;

        if (userRole === USER_ROLES.DSLR) {
            fetchUsers(); // populates Surveyor dropdown
        } else if (userRole === USER_ROLES.SURVEYOR) {
            fetchUsersSlr(); // populates SLR dropdown
        }

        const today = new Date().toISOString().slice(0, 10);
        setRoleFormData(prev => ({
            ...prev,
            dlsr_survey_application_date: prev.dlsr_survey_application_date || today,
            dlsr_gov_fee_payment_date: prev.dlsr_gov_fee_payment_date || today,
            surveyor_joint_survey_start_date: prev.surveyor_joint_survey_start_date || today,
            surveyor_joint_survey_end_date: prev.surveyor_joint_survey_end_date || today,
        }));
    }, [showRoleModal, userRole]);

    // for dtes in showrolemodal
    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setRoleFormData(prev => ({
            ...prev,
            dlsr_survey_application_date: today,
            dlsr_gov_fee_payment_date: today,
            surveyor_joint_start_date: today,
            surveyor_joint_end_date: today
        }));
    }, []);

    // useEffect(() => {
    //     const checkAllButtonStatus = async () => {
    //         if (!currentProjectId || !proposalId) return;

    //         const [laoStatus, surveyorStatus] = await Promise.all([
    //             checkButtonStatus('LAOV'),
    //             checkButtonStatus('Surveyor')
    //         ]);

    //         setButtonStatus({
    //             sendBackToLAO: laoStatus,
    //             assignSurveyor: surveyorStatus
    //         });
    //     };

    //     checkAllButtonStatus();
    // }, [currentProjectId, proposalId, measurements]);

    const refetchAllMeasurements = async () => {
        if (!currentProjectId && !proposalId) {
            return;
        }

        setLoadingMeasurements(true);

        try {
            console.log('🔍 Loading ALL measurement data for project:', currentProjectId, 'proposal:', proposalId);

            // Call API without location filters to get all measurements
            const result = await apiService.getAllRailwayOwner(
                null, // districtName
                null, // talukaName  
                null, // villageName
                currentProjectId,
                proposalId
            );
            if (result.status === 200 && result.data && result.data.landAcquisition) {
                console.log("response----------------------------", result.data);
                const processedData = result.data.landAcquisition.flatMap(item => {
                    return (item.owners || []).map(owner => ({
                        ...owner,
                        project_name: item.project_name,
                        landholder_name: item.landholder_name,
                        survey_no: Array.isArray(item.survey_no) ? item.survey_no.join(', ') : item.survey_no,
                        LandAcquisition_id: item.LandAcquisition_id,
                        // district: item.dist_name,
                        // taluka: item.taluka_name,
                        // village: item.village_name,
                    }));
                });

                setMeasurements(processedData);

                if (result.data && result.data.length > 0) {
                    const firstLandRecord = result.data[0];

                    const rows = (firstLandRecord.owners || []).map(owner => ({
                        ...owner,
                        survey_no: firstLandRecord.land_survey_no,
                        irrigable_area: firstLandRecord.irrigable_area,
                        non_irrigable_area: firstLandRecord.non_irrigable_area,
                        total_area: firstLandRecord.total_area,
                        landholder_name: firstLandRecord.landholder_name,
                        aqr_area: firstLandRecord.aqr_area,
                        dist_name: firstLandRecord.dist_name,
                        taluka_name: firstLandRecord.taluka_name,
                        village_name: firstLandRecord.village_name,
                        LandAcquisition_id: firstLandRecord.LandAcquisition_id,
                        nature_of_owner: firstLandRecord.nature_of_owner,
                    }));

                    setLandAcquisitionData(firstLandRecord);
                    setOwnersData(rows);
                    fetchButtonStatus();
                }

            } else {
                setMeasurements([]);
            }
        } catch (error) {
            console.error('❌ Error loading all measurement data:', error);
            setMeasurements([]);
        } finally {
            setLoadingMeasurements(false);
        }
    };

    const fetchUsers = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserRoleSurveyor();
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
                return { success: true };
            }
            return { success: false };
        } catch (error) {
            console.error('Error fetching users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUsersSlr = async () => {
        setLoadingUsers(true);
        try {
            const response = await apiService.getAllUserRoleSLR();
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUserslao = async () => {
        setLoadingUsers(true);
        try {
            const role = 3;
            const response = await apiService.getAssignLAO(role, currentProjectId, proposalId);
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            setUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUsersAgricultureAgency = async () => {
        setLoadingUsers(true);
        try {
            const role = 21;
            const response = await apiService.get("getAllUser", { role, currentProjectId, proposalId });
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setAgricultureUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            setAgricultureUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUsersTpAgency = async () => {
        setLoadingUsers(true);
        try {
            const role = 23;
            const response = await apiService.get("getAllUser", { role, currentProjectId, proposalId });
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setTpUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            setTpUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    const fetchUsersForestAgency = async () => {
        setLoadingUsers(true);
        try {
            const role = 24;
            const response = await apiService.get("getAllUser", { role, currentProjectId, proposalId });
            console.log('Users response:', response);
            if (response.status === 200 && response.data) {
                setForestUsers(Array.isArray(response.data) ? response.data : []);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
            setForestUsers([]);
        } finally {
            setLoadingUsers(false);
        }
    };

    if (showSection19) {
        return <Section19 onBack={() => setShowSection19(false)} />;
    }

    const handleDeleteRecord = async (owner) => {
        if (!owner.land_owner_id) {
            showAlert('Invalid record ID', 'Cannot delete record without valid ID', 'error');
            return;
        }

        // Show confirmation dialog
        showConfirm(
            'Delete Record',
            `Are you sure you want to delete the record for "${owner.owner_name}"? This action cannot be undone.`,
            async () => {
                try {
                    setLoading(true);

                    // Soft delete by setting is_active to 0
                    const updatePayload = {
                        is_active: 0
                    };

                    // Call patch update API with is_active: 0
                    const response = await apiService.patchUpdateRailwayMeasurement(
                        owner.land_owner_id,
                        updatePayload
                    );

                    if (response.status === 200) {
                        showAlert('Success', 'Record deleted successfully!', 'success');

                        // Refresh the measurements list
                        await fetchMeasurementData();
                    } else {
                        showAlert('Error', 'Failed to delete record. Please try again.', 'error');
                    }
                } catch (error) {
                    console.error('Error deleting record:', error);
                    showAlert('Error', 'Error occurred while deleting record. Please try again.', 'error');
                } finally {
                    setLoading(false);
                }
            },
            null,
            'danger'
        );
    };

    const handleViewDocument = (file) => {
        const url = URL.createObjectURL(file);
        setDocumentUrl(url);
        setShowModal(true);
    };

    const handleSendToSLR = async () => {
        if (!selectedUser || !selectedDocument) {
            toast.error('Please select a user and upload a document', {
                duration: 4000,
                position: 'top-right',
            });
            return;
        }

        // Get only verified land acquisition IDs
        const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

        if (!verifiedLandAcquisitionIds) {
            toast.error('No verified measurements found to send', {
                duration: 4000,
                position: 'top-right',
            });
            return;
        }

        setSendingToLAO(true);
        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('justification', justification);
            formData.append('usr_id', selectedUser);
            formData.append('document', selectedDocument);
            formData.append('landAqusition_id', verifiedLandAcquisitionIds);

            const response = await apiService.postRailwayTrackingSLR(formData);
            console.log('Send to SLR response:', response);

            if (response.status === 200) {
                // 🔥 CHANGED: Show toast AFTER successful API call
                toast.success('Successfully sent verified measurements to DSLR Officer!', {
                    duration: 4000,
                    position: 'top-right',
                });

                setHasFirstSentToLAO(true); // 🔥 SET RED FLAG
                setShowSendToSLRModal(false)

                // Reset form
                setShowSendToSLRModal(false);
                setSelectedUser('');
                setRemarks('Approved');
                setSelectedDocument(null);
                setHasFirstSentToLAO(true);
                setShowSendToSLRModal(false);
                resetSignatureState();
                await (filterMode === 'all' ? refetchAllMeasurements() : fetchMeasurementData());

            } else {
                toast.error('Failed to send to DSLR Officer. Please try again.', {
                    duration: 4000,
                    position: 'top-right',
                });
            }
        } catch (error) {
            console.error('Error sending to DSLR:', error);
            toast.error('Error occurred while sending to DSLR. Please try again.', {
                duration: 4000,
                position: 'top-right',
            });
        } finally {
            setSendingToLAO(false);
        }
    };

    // //Button visiblity
    // const checkButtonStatus = async (type) => {
    //     try {
    //         let response;
    //         if (type === 'LAOV') {
    //             response = await apiService.getSendBackToLAOButton(currentProjectId, proposalId, 'LAOV');
    //         } else if (type === 'Surveyor') {
    //             response = await apiService.getAssignSurveyorButton(currentProjectId, proposalId, 'Surveyor');
    //         }

    //         // Return true if API call was already made (button should be disabled/hidden)
    //         return response?.status === 200 && response?.data?.already_sent === true;
    //     } catch (error) {
    //         console.error(`Error checking ${type} button status:`, error);
    //         return false;
    //     }
    // };
    // // Add these helper functions before your return statement
    // const getButtonVisibilityConditions = () => {
    //     const totalMeasurements = measurements.length;

    //     const slrVerifiedCount = measurements.filter(m => m.is_SLRVerified === true).length;
    //     const surveyorVerifiedCount = measurements.filter(m => m.is_surveyorVerified === true).length;
    //     const unassignedCount = measurements.filter(m =>
    //         m.is_SLRVerified === null && m.is_surveyorVerified === null
    //     ).length;

    //     return {
    //         totalMeasurements,
    //         slrVerifiedCount,
    //         surveyorVerifiedCount,
    //         unassignedCount,
    //         hasMeasurements: totalMeasurements > 0
    //     };
    // };
    // const renderSurveyorButtons = () => {
    //     const conditions = getButtonVisibilityConditions();

    //     if (!conditions.hasMeasurements || conditions.surveyorVerifiedCount === 0) {
    //         return null;
    //     }

    //     return (
    //         <div className="flex items-center gap-4">
    //             {/* Send Back to DSLR Button - Show when there are surveyor verified measurements */}
    //             <button
    //                 onClick={async () => {
    //                     setShowSendBackToDSLRModal(true);
    //                     await fetchUsersSlr();
    //                 }}
    //                 className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${hasFirstSentToDSLR
    //                     ? 'bg-red-600 text-white hover:bg-red-700'
    //                     : 'bg-blue-600 text-white hover:bg-blue-700'
    //                     }`}
    //             >
    //                 <ArrowLeft className="mr-2 h-5 w-5" />
    //                 <span>
    //                     {hasFirstSentToDSLR
    //                         ? `Re-send Back to DSLR (${conditions.surveyorVerifiedCount}/${conditions.totalMeasurements})`
    //                         : `Send Back to DSLR (${conditions.surveyorVerifiedCount}/${conditions.totalMeasurements})`
    //                     }
    //                 </span>
    //             </button>
    //         </div>
    //     );
    // };

    // const renderRoleBasedButtons = () => {
    //     if (userRole === USER_ROLES.DSLR && !hasSentBackToSLR) {
    //         return renderDSLRButtons();
    //     } else if (userRole === USER_ROLES.SURVEYOR) {
    //         return renderSurveyorButtons();
    //     }
    //     return null;
    // };

    // Button Disable
    const fetchButtonStatus = async () => {
        try {
            const projectId = currentProjectId;

            if (!projectId || !proposalId) return;
            let response;

            switch (userRole) {
                case USER_ROLES.DSLR:
                    const surveyorResponse = await apiService.getRailwayAssignSurveyorButton(projectId, proposalId);
                    setSurveyorButtonDisabled(!surveyorResponse.buttonDisable);
                    const laoResponse = await apiService.getRailwaySendBackToLAOButton(projectId, proposalId);
                    setLaoButtonDisabled(!laoResponse.buttonDisable);
                    break;
                case USER_ROLES.LAO:
                    const agencyResponse = await apiService.getRailwayAgencyButton(projectId, proposalId);
                    setAgencyButtonDisabled(!agencyResponse.buttonDisable);
                    break;
                case USER_ROLES.SURVEYOR:
                    response = await apiService.getRailwayAssignBackToDSLRButton(projectId, proposalId);
                    setDslrButtonDisabled(!response.buttonDisable);
                    break;
                default:
                    return;
            }

        } catch (error) {
            console.error("Error fetching DSLR button state:", error);
        } finally {
            // setLoading(false); // Only set loading to false for main data fetch
        }
    };

    let unassignedLandAcquisitionIds = [
        ...new Set(
            (landAcquisitionData || [])
                .map(item => item.LandAcquisition_id)
                .filter(id => id !== null && id !== undefined && id !== '')
        )
    ].join(',');

    // REPLACE your handleSendToSurveyor function with this:
    const handleSendToSurveyor = async () => {
        if (!selectedUser || !selectedDocument) {
            toast.error('Please select a user and upload a document', {
                duration: 4000,
                position: 'top-right',
            });
            return;
        }
        const docu = selectedSignDocument || selectedDocument
        setSendingToLAO(true);
        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', docu);
            formData.append('landAqusition_id', unassignedLandAcquisitionIds);

            const response = await apiService.postRailwayTrackingSurveyor(formData);
            console.log('Send to Surveyor response:', response);

            if (response.status === 200) {
                toast.success('Successfully assigned measurements to Surveyor!', {
                    duration: 4000,
                    position: 'top-right',
                });

                console.log(docu)

                // Update button status after successful API call
                setButtonStatus(prev => ({ ...prev, assignSurveyor: true }));
                setHasSentToSurveyor(true);
                setHasAssignedToSurveyor(true);
                setHasFirstSentToSurveyor(true);
                setShowSendToSurveyorModal(false);
                setShowRoleModal(false);
                setSelectedUser('');
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
                resetSignatureState();

                await (filterMode === 'all' ? refetchAllMeasurements() : fetchMeasurementData());
            } else {
                toast.error('Failed to assign to Surveyor. Please try again.', {
                    duration: 4000,
                    position: 'top-right',
                });
            }
        } catch (error) {
            console.error('Error assigning to Surveyor:', error);
            toast.error('Error occurred while assigning to Surveyor. Please try again.', {
                duration: 4000,
                position: 'top-right',
            });
        } finally {
            setSendingToLAO(false);
        }
    };

    // NEW: Send Back to LAO (from DSLR)
    const handleSendBackToLAO = async () => {
        if (!selectedUser || !selectedDocument) {
            toast.error('Please select a user and upload a document', {
                duration: 4000,
                position: 'top-right',
            });
            return;
        }

        // if (!verifiedLandAcquisitionIds) {
        //     toast.error('No verified measurements found to send back', {
        //         duration: 4000,
        //         position: 'top-right',
        //     });
        //     return;
        // }

        setSendingToLAO(true);
        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', selectedDocument);
            formData.append('landAqusition_id', unassignedLandAcquisitionIds);

            const response = await apiService.postRailwayTrackingbacktoLao(formData);

            if (response.status === 200) {
                handleVerification(unassignedLandAcquisitionIds);
                toast.success('Successfully sent verified measurements back to LAO!', {
                    duration: 4000,
                    position: 'top-right',
                });

                setHasFirstSentToLAO(true);
                setShowSendBackToLAOModal(false);
                setSelectedUser('');
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
                resetSignatureState();

                await (filterMode === 'all' ? refetchAllMeasurements() : fetchMeasurementData());
            } else {
                toast.error('Failed to send back to LAO Officer. Please try again.', {
                    duration: 4000,
                    position: 'top-right',
                });
            }
        } catch (error) {
            console.error('Error sending back to LAO:', error);
            toast.error('Error occurred while sending back to LAO. Please try again.', {
                duration: 4000,
                position: 'top-right',
            });
        } finally {
            setSendingToLAO(false);
        }
    };

    // NEW: Send Back to DSLR (from Surveyor)
    const handleSendBackToDSLR = async () => {
        if (!selectedUser || !selectedDocument) {
            toast.error('Please select a user and upload a document', {
                duration: 4000,
                position: 'top-right',
            });
            return;
        }

        setSendingToLAO(true);
        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarks);
            formData.append('usr_id', selectedUser);
            formData.append('document', selectedDocument);
            formData.append('landAqusition_id', unassignedLandAcquisitionIds);

            const response = await apiService.postRailwayTrackingbacktoSlr(formData);

            if (response.status === 200) {
                handleVerification(unassignedLandAcquisitionIds);
                toast.success('Successfully sent completed measurements back to DSLR!', {
                    duration: 4000,
                    position: 'top-right',
                });

                setShowSendBackToDSLRModal(false);
                setSelectedUser('');
                setRemarks('Approved');
                setSelectedDocument(null);
                fetchButtonStatus();
                resetSignatureState();

                await (filterMode === 'all' ? refetchAllMeasurements() : fetchMeasurementData());
            } else {
                toast.error('Failed to send back to DSLR Officer. Please try again.', {
                    duration: 4000,
                    position: 'top-right',
                });
            }
        } catch (error) {
            console.error('Error sending back to DSLR:', error);
            toast.error('Error occurred while sending back to DSLR. Please try again.', {
                duration: 4000,
                position: 'top-right',
            });
        } finally {
            setSendingToLAO(false);
        }
    };

    const handleSendToAgency = async () => {
        // Validate that at least one agency is selected with document
        if (!hasValidSelection()) {
            showAlert('Please select at least one user with document');
            return;
        }

        const agencies = [];

        // Add selected agencies with their documents
        if (selectedUsers.agriculture && selectedDocuments.agriculture) {
            agencies.push({
                type: 'AgricultureAgency',
                userId: selectedUsers.agriculture,
                document: getDocumentToUpload('agriculture')
            });
        }

        if (selectedUsers.forest && selectedDocuments.forest) {
            agencies.push({
                type: 'ForestAgency',
                userId: selectedUsers.forest,
                document: getDocumentToUpload('forest')
            });
        }

        if (selectedUsers.tp && selectedDocuments.tp) {
            agencies.push({
                type: 'TPAgency',
                userId: selectedUsers.tp,
                document: getDocumentToUpload('tp')
            });
        }
        setSendingToAgency(true);
        try {
            // Prepare all requests
            const requests = agencies.map(({ type, userId, document }) => {
                const formData = new FormData();
                formData.append('project_id', currentProjectId);
                formData.append('proposal_id', proposalId);
                formData.append('remarks', remarks);
                formData.append('usr_id', userId);
                formData.append('document', document);
                formData.append('landAqusition_id', unassignedLandAcquisitionIds);
                // Debug logging
                console.log(`Sending to ${type}:`, {
                    project_id: currentProjectId,
                    proposal_id: proposalId,
                    usr_id: userId,
                    document_name: document.name,
                    document_size: document.size,
                    document_type: document.type,
                    landAqusition_id: unassignedLandAcquisitionIds
                });
                return apiService.postRailwayTrackingAgency(formData, type)
                    .then(res => {
                        console.log(`${type} response:`, res);
                        return { type, status: res.status, data: res.data };
                    })
                    .catch(error => {
                        console.error(`${type} error:`, error);
                        return { type, status: 500, error: error.message };
                    });
            });

            // Run all in parallel
            const results = await Promise.all(requests);

            // Check results
            const successCount = results.filter(r => r.status === 200).length;
            const failCount = results.length - successCount;

            if (successCount > 0) {
                toast.success(`Successfully sent to ${successCount} agencies`);
            }

            if (failCount > 0) {
                results.forEach(({ type, status, error }) => {
                    if (status !== 200) {
                        toast.error(`Failed to send to ${type}: ${error || 'Unknown error'}`);
                    }
                });
            }

            if (successCount > 0) {
                setShowSendToAgencyModal(false);
                setSelectedUsers({ agriculture: '', tp: '', forest: '' });
                setSelectedDocuments({ agriculture: null, forest: null, tp: null });
                setSignedDocuments({ agriculture: null, forest: null, tp: null });
                setRemarks('Approved');
                setCurrentSigningAgency(null);
                fetchButtonStatus();
                resetSignatureState();

                await (filterMode === 'all' ? refetchAllMeasurements() : fetchMeasurementData());
            }

        } catch (error) {
            console.error("Error in sending to agencies:", error);
            toast.error("Error occurred while sending");
        } finally {
            setSendingToAgency(false);
        }
    };

    // const handleFileUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setUploadedFile(file);
    //     }
    // };

    //viewImage
    const imageFiles = uploadedFiles.filter(file => file.type.startsWith('image/'));

    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.25, 3));
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
    };

    const downloadImage = (file) => {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const handleUpdateMeasurement = async () => {
        try {
            // Check if land_owner_id exists
            if (!currentEditData.land_owner_id) {
                showAlert('Error', 'Land Owner ID is missing. Cannot update measurement.', 'error');
                return;
            }

            setLoading(true);

            const payload = {
                owner_irrigable_area: currentEditData.owner_irrigable_area,
                owner_non_irrigable_area: currentEditData.owner_non_irrigable_area,
            };

            console.log('Updating measurement with payload:', payload);
            console.log('Land Owner ID:', currentEditData.land_owner_id);

            const response = await apiService.patchUpdateRailwayMeasurement(
                currentEditData.land_owner_id,
                payload
            );

            if (response.status === 200) {
                showAlert('Success', 'Measurement updated successfully!', 'success');
                setEditingRowIndex(null);
                setCurrentEditData({});
                await fetchMeasurementData();
            } else {
                showAlert('Error', 'Failed to update measurement. Please try again.', 'error');
            }
        } catch (error) {
            console.error("Error updating measurement:", error);
            showAlert('Error', 'Error occurred while updating measurement. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Solution 1: Hide elements with CSS class during PDF generation
    const handleDownloadPDF = () => {
        const node = document.getElementById("notice-content");
        if (!node) {
            alert("Notice content not found.");
            return;
        }

        // Get all active owners
        const allOwners = landAcquisitionData.flatMap(r => r.owners || []).filter(o => Number(o.is_active) === 1);

        // Calculate totals
        const totals = {
            owner_7_12_irrigable: allOwners.reduce((sum, o) => sum + Number(o.owner_7_12_irrigable_area || 0), 0).toFixed(2),
            owner_7_12_non_irrigable: allOwners.reduce((sum, o) => sum + Number(o.owner_7_12_non_irrigable_area || 0), 0).toFixed(2),
            owner_7_12_total: allOwners.reduce((sum, o) => sum + (Number(o.owner_7_12_irrigable_area || 0) + Number(o.owner_7_12_non_irrigable_area || 0)), 0).toFixed(2),
            owner_total_area: allOwners.reduce((sum, o) => sum + Number(o.owner_total_area || 0), 0).toFixed(2),
            owner_aqr_area: allOwners.reduce((sum, o) => sum + Number(o.owner_aqr_area || 0), 0).toFixed(2),
            owner_irrigable: allOwners.reduce((sum, o) => sum + Number(o.owner_irrigable_area || 0), 0).toFixed(2),
            owner_non_irrigable: allOwners.reduce((sum, o) => sum + Number(o.owner_non_irrigable_area || 0), 0).toFixed(2),
            owner_total: allOwners.reduce((sum, o) => sum + (Number(o.owner_irrigable_area || 0) + Number(o.owner_non_irrigable_area || 0)), 0).toFixed(2)
        };

        const ROWS_PER_PAGE = 12;
        const totalPages = Math.ceil(allOwners.length / ROWS_PER_PAGE);

        // Table header HTML (reused on all pages)
        const tableHeaderHTML = `
        <thead>
            <tr>
                <th rowspan="2">अ.क्र</th>
                <th rowspan="2">भूमापन क्रमांक<br/>(स.नं./ ग.नं.)</th>
                <th colspan="3">भूमापन अभिलेखानुसार तपशिल</th>
                <th colspan="3">प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल</th>
                <th colspan="4">प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल</th>
                <th colspan="2">कब्जेदार तपशील</th>
                <th colspan="6">संपादनाखालील क्षेत्रावरील इतर घटक</th>
                <th rowspan="2">गाव नकाशा व मोका परिस्थिती<br/>यामध्ये तफावत असल्यास,<br/>त्याची कायदेशीर कारणमिमांसा</th>
                <th rowspan="2">शेरा</th>
            </tr>
            <tr>
                <th class="sub">लागवडयोग्य<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">पोट खराब<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">एकूण क्षेत्र<br/>(हे.आर.)</th>
                <th class="sub">अधिकार अभिलेखानुसार<br/>भुधारकाचे नाव</th>
                <th class="sub">धारण केलेले<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">संपादनाखालील अंदाजे<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">सर्व्हे नं. /<br/>गट नंबर</th>
                <th class="sub">लागवडयोग्य<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">पोट खराब<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">संपादनाखालील एकूण<br/>क्षेत्र (हे.आर.)</th>
                <th class="sub">कब्जेदाराचे नाव</th>
                <th class="sub">कब्जेदाराचे हक्क<br/>संपादनाचे स्वरुप</th>
                <th class="sub">फळझाडे<br/>(प्रकार संख्या)</th>
                <th class="sub">वनझाडे<br/>(प्रकार/ संख्या)</th>
                <th class="sub">विहीर / बोअरवेल<br/>(प्रकार/ संख्या)</th>
                <th class="sub">पाईपलाईन<br/>(मीटर)</th>
                <th class="sub">बांधकाम<br/>(स्वरुप /तपशिल)</th>
                <th class="sub">इतर</th>
            </tr>
        </thead>
    `;

        const win = window.open("", "", "height=900,width=1200");
        let pagesHTML = '';

        for (let pageNum = 0; pageNum < totalPages; pageNum++) {
            const startIdx = pageNum * ROWS_PER_PAGE;
            const endIdx = Math.min(startIdx + ROWS_PER_PAGE, allOwners.length);
            const pageOwners = allOwners.slice(startIdx, endIdx);
            const isFirstPage = pageNum === 0;
            const isLastPage = pageNum === totalPages - 1;

            // Build rows for this page
            let rowsHTML = '';
            let globalSr = startIdx + 1;

            pageOwners.forEach((owner) => {
                rowsHTML += `
                <tr class="${Number(owner.is_active) === 0 ? 'inactive-row' : ''}">
                    <td>${globalSr++}</td>
                    <td>${owner.survey_no || 'N/A'}</td>
                    <td>${owner.owner_7_12_irrigable_area || '0'}</td>
                    <td>${owner.owner_7_12_non_irrigable_area || '0'}</td>
                    <td>${(parseFloat(owner.owner_7_12_irrigable_area || 0) + parseFloat(owner.owner_7_12_non_irrigable_area || 0)).toFixed(2)}</td>
                    <td>${owner.owner_name || 'N/A'}</td>
                    <td>${owner.owner_total_area || '0'}</td>
                    <td>${owner.owner_aqr_area || '0'}</td>
                    <td>${owner.survey_no || '0'}</td>
                    <td>${owner.owner_irrigable_area || '0'}</td>
                    <td>${owner.owner_non_irrigable_area || '0'}</td>
                    <td>${(parseFloat(owner.owner_irrigable_area || 0) + parseFloat(owner.owner_non_irrigable_area || 0)).toFixed(2)}</td>
                    <td>${owner.actual_occupant || '0'}</td>
                    <td>${owner.nature_of_owner || '-'}</td>
                    <td class="text-xs">${owner.tree ? owner.tree.filter(t => t.tree_type_name1 === "फळझाडे").map(t => `${t.tree_type_name}-${t.tree_count}`).join(', ') : '0'}</td>
                    <td class="text-xs">${owner.tree ? owner.tree.filter(t => t.tree_type_name1 === "वनझाडे").map(t => `${t.tree_type_name}-${t.tree_count}`).join(', ') : '0'}</td>
                    <td class="text-xs">${[
                        ...(owner.well || []).map(w => `विहीर (${w.Property_length}m×${w.Property_depth}m)`),
                        ...(owner.borewell || []).map(b => `बोअरवेल (${b.Property_depth}m)`)
                    ].join(', ') || '0'}</td>
                    <td class="text-xs">${(owner.pipeline || []).map(p => `पाईपलाईन (${p.Property_length}m×${p.Property_width}m)`).join(', ') || '0'}</td>
                    <td class="text-xs">${[
                        ...(owner.home || []).map(h => `घर (${h.house_floor_no?.replace(/_/g, ' ')} ${h.Property_width}m×${h.Property_length}m)`),
                        ...(owner["tinshed/godown"] || []).map(t => `टिनशेड (${t.Property_length}m×${t.Property_width}m)`)
                    ].join(', ') || '0'}</td>
                    <td class="text-xs">${[
                        ...(owner.wirefencing || []).map(w => `wirefencing (${w.Property_length}m)`),
                        ...(owner.farmpond || []).map(f => `farmpond (${f.Property_length}m×${f.Property_width}m×${f.Property_depth}m)`),
                        ...(owner.other || []).map(o => `${o.construction_type}-${o.Property_count}`)
                    ].join(', ') || '0'}</td>
                    <td class="text-left text-xs">${owner.remarks || ''}</td>
                    <td class="text-left text-xs">${owner.justification || ''}</td>
                </tr>
            `;
            });

            // Add totals row on last page
            if (isLastPage) {
                rowsHTML += `
                <tr class="totals-row">
                    <td colspan="2"><strong>एकूण</strong></td>
                    <td><strong>${totals.owner_7_12_irrigable}</strong></td>
                    <td><strong>${totals.owner_7_12_non_irrigable}</strong></td>
                    <td><strong>${totals.owner_7_12_total}</strong></td>
                    <td></td>
                    <td><strong>${totals.owner_total_area}</strong></td>
                    <td><strong>${totals.owner_aqr_area}</strong></td>
                    <td></td>
                    <td><strong>${totals.owner_irrigable}</strong></td>
                    <td><strong>${totals.owner_non_irrigable}</strong></td>
                    <td><strong>${totals.owner_total}</strong></td>
                    <td colspan="10"></td>
                </tr>
            `;
            }

            pagesHTML += `
            <div class="page">
 ${isFirstPage ? `
        <div style="display:flex; justify-content:space-between; align-items:flex-start; width:100%;">
            
            <!-- Left block -->
            <div style="flex:1; text-align:left; font-size:12px; line-height:1.6;padding-top:40px;">
                <p><strong>भूसंपादन प्रकरण क्रमांक :</strong> ${proposalDetails?.section_11_bhusampadan_no || ""} 
                <p><strong>संपादन संस्था :</strong> ${proposalDetails?.acquisition_incharge_designation || ""}</p>
                <p><strong>भूमि संपादनाचे प्रयोजन :</strong> ${proposalDetails?.acquisition_purpose || ""}</p>
            </div>

            <!-- Center Title -->
            <div style="flex:1; text-align:center;">
                <h2 style="font-size:18px; font-weight:bold; text-decoration:underline; margin:0;padding-top:10px;">
                    संयुक्त मोजणी अहवाल
                </h2>
            </div>

            <!-- Right block -->
            <div style="flex:1; text-align:right; font-size:12px; line-height:1.6;padding-top:40px;">
                ${roleFormData.surveyor_joint_start_date && roleFormData.surveyor_joint_end_date ? `
                    <p><strong>प्रारंभ दिनांक :</strong> 
                        ${new Date(roleFormData.surveyor_joint_start_date).toLocaleDateString('hi-IN')}
                    </p>
                    <p><strong>समाप्ती दिनांक :</strong> 
                        ${new Date(roleFormData.surveyor_joint_end_date).toLocaleDateString('hi-IN')}
                    </p>
                     <p><strong>मो. र. क्रमांक :</strong> 
                        ${new Date(roleFormData.surveyor_m_r_no).toLocaleDateString('hi-IN')}
                    </p>
                ` : ""}
            </div>
        </div>
          <div style="text-align:center; margin-top:24px; margin-bottom:12px;">
          <h2 style="font-size:18px; font-weight:bold; margin:0;">
              मोजे: ${proposalDetails?.village_name || ""}, तालुका: ${proposalDetails?.taluka_name || ""}, जिल्हा: ${proposalDetails?.dist_name || ""}
          </h2>
      </div>
` : ''}
                <!-- Table -->
                <table>
                    ${tableHeaderHTML}
                    <tbody>
                        ${rowsHTML}
                    </tbody>
                </table>

                <!-- Footer Signatures -->
                <div class="footer-section">
                    <div class="signatures">
                        <div><p>ग्राम महसूल अधिकारी</p></div>
                        <div><p>वनरक्षक</p></div>
                        <div><p>कृषि सहायक / मंडळ अधिकारी (कृषि)</p></div>
                        <div><p>संपादन संस्थेचा प्रतिनिधी</p></div>
                        <div><p>भूकरमापक</p></div>
                        <div><p>छाननी लिपीक</p></div>
                        <div><p>उप-अधीक्षक भूमि अभिलेख</p></div>
                    </div>
                </div>
            </div>
        `;
        }

        win.document.write(`
        <html>
        <head>
            <title>संयुक्त मोजणी अहवाल</title>
            <style>
                @page {
                    size: A4 landscape;
                    margin: 20px;
                }
                @media print {
                    body {
                        margin: 20px;
                    }
                    @page { margin: 0; }
                    html, body {
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                }
                body {
                    font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
                    margin: 20px;
                    padding: 0;
                }
                .page {
                    page-break-after: always;
                    position: relative;
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                }
                .page:last-child {
                    page-break-after: auto;
                }
                .header-section {
                    margin-bottom: 10px;
                }
                .flex { display: flex; }
                .justify-between { justify-content: space-between; }
                .items-start { align-items: flex-start; }
                .text-left { text-align: left; }
                .text-center { text-align: center; }
                .text-right { text-align: right; }
                .flex-1 { flex: 1; }
                .flex-shrink-0 { flex-shrink: 0; }
                .pr-8 { padding-right: 2rem; }
                .pl-8 { padding-left: 2rem; }
                .title {
                    font-size: 20px;
                    font-weight: bold;
                    text-decoration: underline;
                    margin: 10px 0;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 9px;
                }
                th, td {
                    border: 1px solid #000;
                    padding: 3px 4px;
                    text-align: center;
                    vertical-align: top;
                }
                th {
                    background: #f0f0f0;
                    font-weight: bold;
                }
                th.sub {
                    font-size: 8px;
                    font-weight: 600;
                }
                .text-xs {
                    font-size: 8px;
                }
                .inactive-row {
                    text-decoration: line-through;
                    opacity: 0.6;
                    background: #f3f4f6;
                }
                .totals-row {
                    background: #e5e7eb;
                    font-weight: bold;
                }
                .footer-section {
                    margin-top: auto;
                    padding-top: 60px;
                }
                .signatures {
                    display: grid;
                    grid-template-columns: repeat(7, 1fr);
                    gap: 10px;
                    text-align: center;
                }
                .signatures div {
                    min-height: 60px;
                }
                .signatures p {
                    margin: 0;
                    font-size: 10px;
                    font-weight: 600;
                }
            </style>
        </head>
        <body>
            ${pagesHTML}
        </body>
        </html>
    `);

        win.document.close();
        win.focus();
        setTimeout(() => win.print(), 250);
    };

    const LandSelectionModal = () => {
        const [selectedLandId, setSelectedLandId] = useState('');

        const handleLandSelection = () => {
            if (!selectedLandId) {
                showAlert('Error', 'कृपया अ.क्र निवडा', 'error');
                return;
            }

            const selectedLand = landAcquisitionData.find(land =>
                land.LandAcquisition_id.toString() === selectedLandId
            );

            if (selectedLand) {
                setSelectedLandRecord(selectedLand);
                setShowLandSelectionModal(false);
                setShowAddOwner(true);
            } else {
                showAlert('Error', 'निवडलेली भूमि सापडली नाही', 'error');
            }
        };

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-xl font-semibold text-gray-800">भूमि निवड करा</h3>
                            <button
                                onClick={() => setShowLandSelectionModal(false)}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X className="h-6 w-6" />
                            </button>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    अ.क्र निवडा *
                                </label>
                                <select
                                    value={selectedLandId}
                                    onChange={(e) => setSelectedLandId(e.target.value)}
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                >
                                    <option value="">अ.क्र निवडा...</option>
                                    {landAcquisitionData && landAcquisitionData.map((land, index) => (
                                        <option
                                            key={land.LandAcquisition_id}
                                            value={land.LandAcquisition_id}
                                        >
                                            अ.क्र {index + 1} - सर्व्हे नं: {land.survey_no} - भूधारक: {land.landholder_name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {selectedLandId && (
                                <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                                    {(() => {
                                        const selectedLand = landAcquisitionData.find(land =>
                                            land.LandAcquisition_id.toString() === selectedLandId
                                        );
                                        return selectedLand ? (
                                            <div className="text-sm">
                                                <p><strong>सर्व्हे नं:</strong> {selectedLand.survey_no}</p>
                                                <p><strong>भूधारक:</strong> {selectedLand.landholder_name}</p>
                                                <p><strong>एकूण क्षेत्र:</strong> {selectedLand.total_area} हेक्टर</p>
                                                <p><strong>संपादन क्षेत्र:</strong> {selectedLand.aqr_area} हेक्टर</p>
                                                <p><strong>गाव:</strong> {selectedLand.village_name}</p>
                                            </div>
                                        ) : null;
                                    })()}
                                </div>
                            )}
                        </div>

                        <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                            <button
                                onClick={() => setShowLandSelectionModal(false)}
                                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                            >
                                रद्द करा
                            </button>
                            <button
                                onClick={handleLandSelection}
                                disabled={!selectedLandId}
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                            >
                                <Users className="mr-2 h-4 w-4" />
                                कब्जेदार जोडा
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ADD THIS FUNCTION AROUND LINE 1440, WITH OTHER HELPER FUNCTIONS:

    const handleAddOwnerClick = () => {
        if (!landAcquisitionData || landAcquisitionData.length === 0) {
            showAlert('Error', 'भूमि डेटा उपलब्ध नाही', 'error');
            return;
        }

        if (landAcquisitionData.length === 1) {
            // If only one land record, directly open AddOwner
            setSelectedLandRecord(landAcquisitionData[0]);
            setShowAddOwner(true);
        } else {
            // If multiple land records, show selection modal
            setShowLandSelectionModal(true);
        }
    };

    // const fetchMeasurementData = async () => {
    //     const response = await apiService.getMeasurementByLandId(landAcquisitionId);
    //     setOwners(response.data);
    //     setLandAcquisition(response.landAcquisition);
    //     fetchMeasurementData();
    // };

    // useEffect(() => {
    //     if (landAcquisitionId) {
    //         console.log('🔄 Reloading measurement data for:', landAcquisitionId);
    //         fetchMeasurementData();
    //     }
    // }, [landAcquisitionId]);


    // Callback function to handle when owner is added
    const handleOwnerAdded = (result) => {
        if (result.status === 200) {
            // Refresh the measurement data to show the new owner
            fetchMeasurementData();

            // Show success message
            setSuccessMessage('Occupant added successfully!');

            // Clear success message after 3 seconds
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        }
    };

    // Callback function to handle when owner is added
    const handleOwnerEdited = (result) => {
        if (result.status === 200) {
            // Refresh the measurement data to show the new owner
            fetchMeasurementData();

            // Show success message
            setSuccessMessage('Occupant added successfully!');

            // Clear success message after 3 seconds
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        }
    };

    const handleIdentityProofChange = (field, value) => {
        setIdentityProofs(prev => ({
            ...prev,
            [field]: value
        }));

        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };


    const loadExistingFiles = async () => {
        try {
            setLoading(true);

            const response = await apiService.getRailwayMeasurementByOwnerID(measurementId);

            if (response.status === 200 && response.data.length > 0) {
                const data = response.data[0]; // assuming response.data is an array
                const files = [];

                Object.entries(data).forEach(([key, value]) => {
                    if (
                        (key.startsWith('image_') || key.startsWith('document_')) &&
                        value &&
                        key !== 'undefined'
                    ) {
                        files.push({
                            id: key,
                            name: key.replace(/_/g, ' ').toUpperCase(),
                            url: value,
                            type: getFileTypeFromUrl(value)
                        });
                    }
                });


                setExistingFiles(files); // ⬅️ this sets the state to display in UI
            }
        } catch (error) {
            console.error('Error loading existing files:', error);
        } finally {
            setLoading(false);
        }
    };

    const getFileTypeFromUrl = (url) => {
        const extension = url.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
        if (['pdf'].includes(extension)) return 'pdf';
        if (['doc', 'docx'].includes(extension)) return 'document';
        return 'file';
    };

    const validateFiles = (files) => {
        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
            'application/pdf', 'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'text/plain'
        ];

        const errors = [];

        files.forEach((file, index) => {
            if (file.size > maxFileSize) {
                errors.push(`File ${index + 1} (${file.name}) is too large. Maximum size is 10MB.`);
            }

            if (!allowedTypes.includes(file.type)) {
                errors.push(`File ${index + 1} (${file.name}) has unsupported type: ${file.type}`);
            }
        });

        return errors;
    };

    // Enhanced file size formatter
    // const formatFileSize = (bytes) => {
    //     if (bytes === 0) return '0 B';

    //     const k = 1024;
    //     const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    //     const i = Math.floor(Math.log(bytes) / Math.log(k));

    //     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    // };

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        const validationErrors = validateFiles(files);

        if (validationErrors.length > 0) {
            showAlert('File validation errors:\n' + validationErrors.join('\n'));
            return;
        }

        setUploadedFiles(files);
    };


    const handleViewFile = (file) => {
        if (file.type === 'image') {
            setSelectedFilePreview(file);
            setViewMode('preview');
        } else {
            // For non-image files, open in new tab
            window.open(file.url, '_blank');
        }
    };

    const getFileIcon = (type) => {
        switch (type) {
            case 'image': return <Image className="h-4 w-4" />;
            case 'pdf': return <FileType className="h-4 w-4" />;
            default: return <FileText className="h-4 w-4" />;
        }
    };

    const handleLAOEditButtonClick = (owner, rowIndex = null) => {
        setEditingRowIndex(owner.land_owner_id);
        setCurrentEditData({
            land_owner_id: owner.land_owner_id,
            owner_irrigable_area: owner.owner_irrigable_area || "",
            owner_non_irrigable_area: owner.owner_non_irrigable_area || "",
        });

    };
    const handleSurveyorEditButtonClick = (owner) => {
        console.log("🖊️ handleEditButtonClick received owner:", owner);
        setSelectedOwner(owner);
        setSelectedOwnerInDetails(owner);

        // Create fresh editFormData without spreading old data
        const newEditFormData = {
            // IDs and core data
            land_owner_id: owner.land_owner_id,
            LandAcquisition_id: owner.LandAcquisition_id,
            project_id: owner.project_id || currentProjectId,
            proposal_id: owner.proposal_id || proposalId,

            // Owner information
            actual_occupant: owner.actual_occupant || '',
            owner_type: owner.owner_type || '',
            owner_contact: owner.owner_contact || '',
            owner_email: owner.owner_email || '',
            owner_address: owner.owner_address || '',
            aadhaar_number: owner.aadhaar_number || '',
            pan_number: owner.pan_number || '',
            nature_of_owner: owner.nature_of_owner || '',


            // Location
            latitude: owner.latitude || '',
            longitude: owner.longitude || '',

            // Land details
            survey_no: owner.survey_no || '',
            land_area: owner.land_area || '',
            land_category: owner.land_category || '',
            land_use: owner.land_use || '',

            // Assets (matching your JSON structure)
            no_of_tree: owner.no_of_tree || '',
            no_of_home: owner.no_of_home || '',
            no_of_tinshed: owner.no_of_tinshed || '',
            no_of_water_body: owner.no_of_water_body || '',
            no_of_borewell: owner.no_of_borewell || '',
            no_of_pipeline: owner.no_of_pipeline || '',
            no_of_wirefencing: owner.no_of_wirefencing || '',
            no_of_fram_pound: owner.no_of_fram_pound || '',
            no_of_other_asset: owner.no_of_other_asset || '',

            // Area information
            owner_irrigable_area: owner.owner_irrigable_area || '',
            owner_non_irrigable_area: owner.owner_non_irrigable_area || '',
            owner_7_12_irrigable_area: owner.owner_7_12_irrigable_area || '',
            owner_7_12_non_irrigable_area: owner.owner_7_12_non_irrigable_area || '',
            owner_total_area: owner.owner_total_area || owner.owner_aqr_area || '',

            // Other fields
            remarks: owner.remarks || '',
            justification: owner.justification || '',
            solatium_percentage: owner.solatium_percentage || '',
            total_percentage: owner.total_percentage || ''
        };

        setEditFormData(newEditFormData);

        console.log("📝 Setting editFormData with:", {
            land_owner_id: owner.land_owner_id,
            actual_occupant: owner.actual_occupant,
            owner_type: owner.owner_type
        });

        // Open modal
        setShowEditOwner(true);
    };

    const handleEditInputChange = (field, value) => {
        setCurrentEditData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleFormChange = (field, value) => {
        setEditFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    // Validation function
    const validateFormData = () => {
        const newErrors = {};

        if (!editFormData.survey_no?.trim()) {
            newErrors.survey_no = 'Survey number is required';
        }

        if (!editFormData.landholder_name?.trim()) {
            newErrors.landholder_name = 'Landholder name is required';
        }

        if (!editFormData.total_area || parseFloat(editFormData.total_area) <= 0) {
            newErrors.total_area = 'Total area must be greater than 0';
        }

        if (!editFormData.aqr_area || parseFloat(editFormData.aqr_area) <= 0) {
            newErrors.aqr_area = 'Acquired area must be greater than 0';
        }

        // Check if acquired area is not greater than total area
        if (parseFloat(editFormData.aqr_area) > parseFloat(editFormData.total_area)) {
            newErrors.aqr_area = 'Acquired area cannot be greater than total area';
        }
        if (identityProofs.aadhaarNumber && !/^\d{12}$/.test(identityProofs.aadhaarNumber)) {
            newErrors.aadhaarNumber = 'Aadhaar number must be 12 digits';
        }

        if (identityProofs.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(identityProofs.panNumber)) {
            newErrors.panNumber = 'Invalid PAN number format';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleAddOwner = (result) => {
        console.log('Occupant added:', result);
        setShowAddOwner(false);
        setNewOwner({});
    };
    const handleEditOwner = (result) => {
        console.log('Occupant edited:', result);
        setShowEditOwner(false);
        setEditFormData({});
        setSelectedOwner(null);
        setSelectedOwnerInDetails(null);

        // Refresh the measurement data after editing
        if (result?.status === 200) {
            fetchMeasurementData();
            showAlert('Success', 'Occupant updated successfully!', 'success');
        }
    };

    const handleCancel = () => {
        setShowAddOwner(false);
        setNewOwner({});
    };

    const handleCancelEdit = () => {
        setShowEditOwner(false);
        setEditFormData({});
        setSelectedOwner(null);
        setSelectedOwnerInDetails(null);
        setEditingRowIndex(null);
        setCurrentEditData({});
    };

    const handleUpdate = async (index) => {
        try {
            setUpdating(true);

            const ownerToUpdate = ownersData[index];
            if (!ownerToUpdate?.land_owner_id) {
                showAlert('Occupant ID not found. Cannot update.');
                return;
            }

            const updatePayload = {
                project_id: ownerToUpdate.project_id,
                LandAcquisition_id: ownerToUpdate.LandAcquisition_id,
                owner_name: editFormData.owner_name || '',
                nature_of_owner: editFormData.nature_of_owner || '',
                owner_type: editFormData.owner_type || '',
                aadhaar_number: editFormData.aadhaar_number || '',
                pan_number: editFormData.pan_number || '',
                owner_contact: editFormData.owner_contact || '',
                owner_email: editFormData.owner_email || '',
                owner_address: editFormData.owner_address || '',
                latitude: parseFloat(editFormData.latitude) || 0,
                latitude: parseFloat(editFormData.latitude) || 0,
                longitude: parseFloat(editFormData.longitude) || 0,
                no_of_home: parseFloat(editFormData.no_of_home) || 0,
                no_of_tinshed: parseFloat(editFormData.no_of_tinshed) || 0,
                no_of_water_body: parseFloat(editFormData.no_of_water_body) || 0,
                no_of_borewell: parseFloat(editFormData.no_of_borewell) || 0,
                no_of_pipeline: parseFloat(editFormData.no_of_pipeline) || 0,
                no_of_wirefencing: parseFloat(editFormData.no_of_wirefencing) || 0,
                no_of_other_asset: parseFloat(editFormData.no_of_other_asset) || 0,
                remarks: editFormData.remarks || '',
                justification: editFormData.justification || '',
                // remarks: parseFloat(editFormData.remarks) || 0,

                is_active: 1
            };

            console.log('Updating row:', index, updatePayload);

            const response = await apiService.patchUpdateRailwayMeasurement(
                ownerToUpdate.land_owner_id,
                updatePayload
            );

            if (response?.status === 200) {
                showAlert('Occupant updated successfully!');
                setEditingRowIndex(null);
                measurementData(); // Refresh after update
            } else {
                showAlert('Update failed. Please try again.');
            }
        } catch (error) {
            console.error('Update error:', error);
            showAlert('An error occurred while updating. Please try again.');
        } finally {
            setUpdating(false);
        }
    };


    const handleLandholderClick = (landAcquisition) => {
        // Handle landholder click if needed
        console.log('Landholder clicked:', landAcquisition);
    };

    // Calculate financial summary
    const calculateFinancialSummary = () => {
        if (!owners || owners.length === 0) {
            return {
                landValue: 0,
                structureValue: 0,
                treeValue: 0,
                cropValue: 0,
                solatiumAmount: 0,
                totalCompensation: 0
            };
        }

        const landValue = parseFloat(landAcquisition?.total_area || 0) * 1000;
        const structureValue = owners.reduce((sum, owner) => sum + parseFloat(owner.structure_compensation || 0), 0);
        const treeValue = owners.reduce((sum, owner) => sum + parseFloat(owner.tree_compensation || 0), 0);
        const cropValue = owners.reduce((sum, owner) => sum + parseFloat(owner.no_of_other_asset || 0), 0);

        // Use dynamic solatium percentage
        const baseAmount = landValue + structureValue + treeValue + cropValue;
        const solatiumAmount = baseAmount * (solatiumPercentage / 100);
        const totalCompensation = baseAmount + solatiumAmount;

        // Calculate total percentage (this could be total compensation as % of some base value)
        const calculatedTotalPercentage = totalCompensation > 0 ? ((totalCompensation / baseAmount - 1) * 100) : 0;

        // Update total percentage state
        if (calculatedTotalPercentage !== totalPercentage) {
            setTotalPercentage(calculatedTotalPercentage);
        }

        return {
            landValue,
            structureValue,
            treeValue,
            cropValue,
            solatiumAmount,
            totalCompensation
        };
    };

    const financialSummary = calculateFinancialSummary();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-80">
                <div className="text-center animate-float">
                    <div className="inline-flex relative">
                        <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                        <div
                            className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0"
                            style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
                        ></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                        </div>
                    </div>
                    <p className="text-gray-400 mt-4">{translations[language]?.loadingMeasurementDetails}</p>
                </div>
            </div>
        );
    }

    if (!landAcquisitionData) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="text-center">
                    <p className="text-red-600">{translations[language]?.noMeasurementData}</p>
                </div>
            </div>
        );
    }
    // const hasSurveyorVerified = landAcquisitionData.filter(m => m.is_surveyorVerified === true);
    const hasDslarVerified = landAcquisitionData.filter(m => m.is_slrVerified === true);
    const hasSurveyorVerified = landAcquisitionData.filter(m =>
        m.is_surveyorVerified === true
    );

    return (
        <div className="w-full bg-white">
            <div className="p-6 border-b bg-gray-50">
                <div className="flex items-center justify-between">
                    {/* <button
                        onClick={() => setShowFilterPanel(!showFilterPanel)}
                        className={`flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md ${showFilterPanel
                            ? 'bg-orange-600 text-white'
                            : 'bg-orange-600 text-white'
                            }`}
                    >
                        <Filter className="h-4 w-4" />
                        <span>{translations[language].Filters}</span>
                        {showFilterPanel ?
                            <ChevronUp className="h-4 w-4" /> :
                            <ChevronDown className="h-4 w-4" />
                        }
                    </button> */}

                    {/* Left side - Back button and location info */}
                    <div className="flex items-center space-x-6">
                        <button
                            onClick={onBack}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors"
                        >
                            <ArrowLeft className="h-5 w-5" />
                        </button>

                        {/* <div className="flex items-center space-x-8">
                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.district}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.dist_name || 'N/A'}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.taluka}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.taluka_name || 'N/A'}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.village}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.village_name || 'N/A'}
                                </p>
                            </div>
                        </div> */}

                        {/* {showconfirm && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">{translations[language]?.confirmDownload}</h3>
                                    <p className="text-gray-600 mb-6">{translations[language]?.confirmDownloadMessage}</p>
                                    <div className="flex justify-end space-x-3">

                                        <button
                                            onClick={() => setShowConfirm(false)}
                                            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-lg transition-colors"
                                        >
                                            {translations[language]?.cancel}
                                        </button>
                                        <button
                                            onClick={handleDownloadPDF}
                                            className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
                                        >
                                            {translations[language]?.download}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>

                    {/* Action Buttons */}
                    {userRole === USER_ROLES.LAO && (
                        <div className="flex items-center gap-4">
                            {/* Send to Agency Button - Always visible */}
                            <button
                                onClick={() => {
                                    if (agencyButtonDisabled) {
                                        showConfirm(
                                            'Re-Send to Agency',
                                            `Are you sure you want to re-send this record to All Agency?`,
                                            () => {
                                                setShowSendToAgencyModal(true)
                                                fetchUsersAgricultureAgency(true)
                                                fetchUsersForestAgency(true)
                                                fetchUsersTpAgency(true)
                                            },
                                            null,
                                            'danger'
                                        );
                                    } else {
                                        setShowSendToAgencyModal(true);
                                        fetchUsersAgricultureAgency(true);
                                        fetchUsersForestAgency(true);
                                        fetchUsersTpAgency(true);
                                    };
                                }}

                                disabled={landAcquisitionData.length === 0}
                                // Remove all disabled conditions - always enabled
                                className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 whitespace-nowrap ${agencyButtonDisabled
                                    ? 'bg-red-600 text-white hover:bg-red-700' // 🔥 RED after first send
                                    : 'bg-indigo-600 text-white hover:bg-indigo-700' // 🔵 Blue for first send
                                    }`}
                            >
                                <Send className="mr-2 h-5 w-5 flex-shrink-0" />
                                <span>
                                    Send All to {translations[language].ConcernValuer} ({landAcquisitionData.length})
                                </span>
                            </button>
                        </div>

                    )}

                    {/* Section 19 Button - Only for Samanvay, Collector, and LAO */}
                    {/* {(userRole === USER_ROLES.SAMANVAY || userRole === USER_ROLES.COLLECTOR || userRole === USER_ROLES.LAO) && (
                        <>
                            <button
                                onClick={() => setSubComponent('Section19')}

                                className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 whitespace-nowrap bg-sky-700 text-gray-100 hover:bg-sky-800 `}
                            >
                                <Send className="mr-2 h-5 w-5 flex-shrink-0" />
                                <span>{translations[language]?.Section19}</span>
                            </button>

                            <button
                                onClick={() => handleSection21_1()}
                                className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                                <span className="font-medium">{translations[language].Section21_1}</span>
                            </button>

                            <button
                                onClick={() => handleSection21_1_4()}
                                className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                                <span className="font-medium">{translations[language].Section21_1_4}</span>
                            </button>
                        </>
                    )} */}
                    {userRole === USER_ROLES.SURVEYOR && (
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => {
                                    if (dlsrButtonDisabled) {
                                        showConfirm(
                                            'Re-Send to DSLR',
                                            `Are you sure you want to re-send this record to DSLR?`,
                                            async () => { setShowRoleModal(true); },
                                            null,
                                            'danger'
                                        );
                                    } else {
                                        setShowRoleModal(true)
                                    };
                                }}
                                disabled={!areAllRowsVerified()}
                                className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${!areAllRowsVerified()
                                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                                    : dlsrButtonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : 'bg-yellow-600 text-white hover:bg-yellow-700'
                                    }`}
                            >
                                <ArrowLeft className="mr-2 h-5 w-5" />
                                <span>
                                    {dlsrButtonDisabled ? 'Re-send Back to DSLR' : 'Send Back to DSLR'}
                                    {!areAllRowsVerified() && ' (Verify All First)'}
                                </span>
                            </button>
                        </div>
                    )}
                    {/* --------- */}
                    {/* {(userRole === USER_ROLES.DSLR) && !hasSentBackToSLR && ( */}
                    {userRole === USER_ROLES.DSLR && (
                        <>
                            {(!hasSurveyorVerified.length && !hasDslarVerified.length) ? (
                                // Show Assign to Surveyor Button

                                <button
                                    onClick={() => {
                                        if (surveyorButtonDisabled) {
                                            showConfirm(
                                                'Re-Send to Surveyor',
                                                `Are you sure you want to re-send this record to Surveyor?`,
                                                async () => { setShowRoleModal(true); },
                                                null,
                                                'danger'
                                            );
                                        } else {
                                            setShowRoleModal(true);
                                        }
                                    }}
                                    disabled={landAcquisitionData.length === 0}
                                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${surveyorButtonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : 'bg-green-600 text-white hover:bg-green-700'
                                        }`}
                                >
                                    <Send className="mr-2 h-5 w-5" />
                                    <span>
                                        {/* {surveyorButtonDisabled
                                            ? 'Re-assign to Surveyor'
                                            : */}
                                        {translations[language].assignToSurveyor}
                                    </span>
                                </button>
                            ) : (hasSurveyorVerified.length && !hasDslarVerified.length) ? (
                                // Show Send Back to LAO Button
                                <button
                                    onClick={() => {
                                        if (laoButtonDisabled) {
                                            showConfirm(
                                                'Re-Send to LAO',
                                                `Are you sure you want to re-send this record to LAO?`,
                                                () => {
                                                    setShowSendBackToLAOModal(true);
                                                    fetchUserslao(true);
                                                },
                                                null,
                                                'danger'
                                            );
                                        } else {
                                            setShowSendBackToLAOModal(true);
                                            fetchUserslao(true);
                                        }
                                    }}

                                    disabled={landAcquisitionData.length === 0}
                                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${laoButtonDisabled
                                        ? 'bg-red-600 text-white hover:bg-red-700'
                                        : 'bg-yellow-600 text-white hover:bg-yellow-700'
                                        }`}
                                >
                                    <ArrowLeft className="mr-2 h-5 w-5" />
                                    <span>
                                        {laoButtonDisabled
                                            ? 'Re-send Back to LAO'
                                            : 'Send Back to LAO'} (All {landAcquisitionData.length})
                                    </span>
                                </button>
                            ) : null}
                        </>
                    )}


                    {/* Download */}
                    <button
                        onClick={handleDownloadPDF}
                        className="px-4 py-2  bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors flex items-center space-x-2"
                    >
                        <Download className="h-4 w-4" />
                        <span>{translations[language]?.download} </span>
                    </button>
                </div>
            </div>


            {/* Error Message */}
            {error && (
                <div className="mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-600 text-sm">{error}</p>
                </div>
            )}

            {/* Table */}
            {/* Rest of the component content - scrollable */}
            <div className="max-h-screen overflow-y-auto p-6">
                {/* Enhanced Main Data Table */}
                <div className="bg-white border-2 border-gray-300 rounded-lg overflow-hidden mb-6 shadow-sm">
                    {/* Add Owner Button - Prominently placed at the top */}
                    {/* {userRole === USER_ROLES.SURVEYOR && (
                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">{translations[language]?.occupantsManagement}</h3>
                                    <p className="text-sm text-gray-600">{translations[language]?.addOrManageOccupants}</p>
                                </div>

                                <button
                                    onClick={handleAddOwnerClick}  // THIS IS THE NEW LINE
                                    className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                                >
                                    <Plus className="h-5 w-5" />
                                    <span className="font-medium">{translations[language]?.addNewOccupantName}</span>
                                </button>
                            </div>
                        </div>
                    )} */}

                    {/* Project Info Header */}
                    <div className="mb-6 px-5 py-5">
                        <div id="notice-content" style={{ margin: "10mm" }}>
                            {/* Main Header Layout */}
                            <div>
                                {/* First Row: Left, Center Title, Right */}
                                <div className="flex justify-between items-start">
                                    {/* Left Side Info */}
                                    {proposalDetails && (
                                        <div className="flex-1 text-left pr-8 mt-20">
                                            <p className="font-semibold">
                                                भूसंपादन प्रकरण क्रमांक : {proposalDetails.section_11_bhusampadan_no || ""}
                                            </p>
                                            <p className="font-semibold">
                                                {/* संपादन संस्था : {proposalDetails.acquisition_agency || ""} */}
                                                संपादन संस्था : {proposalDetails.acquisition_incharge_designation || ""}
                                            </p>
                                            <p className="font-semibold">
                                                भूमि संपादनाचे प्रयोजन : {proposalDetails.acquisition_purpose || ""}
                                            </p>
                                        </div>
                                    )}

                                    {/* Center Title */}
                                    <div className="flex-shrink-0 text-center px-8 mt-5">
                                        <h2 className="text-2xl font-bold text-gray-900 underline whitespace-nowrap">
                                            संयुक्त मोजणी अहवाल
                                        </h2>
                                    </div>

                                    {/* Right Side Info */}
                                    <div className="flex-1 text-right pl-8 mt-20">
                                        <div className="mb-4">
                                            <p className="font-semibold">
                                                {/* प्रस्ताव नाव : {proposalDetails.acquisition_proposal_no || ""} */}
                                            </p>
                                            {roleFormData.surveyor_joint_start_date && roleFormData.surveyor_joint_end_date ? (
                                                <div>
                                                    <p className="font-semibold">
                                                        प्रारंभ दिनांक : {new Date(roleFormData.surveyor_joint_start_date).toLocaleDateString('hi-IN')}
                                                    </p>
                                                    <p className="font-semibold">
                                                        समाप्ती दिनांक : {new Date(roleFormData.surveyor_joint_end_date).toLocaleDateString('hi-IN')}
                                                    </p>
                                                    <p className="font-semibold">
                                                        {translations[language].MRNo} : {roleFormData.surveyor_m_r_no}
                                                    </p>
                                                </div>
                                            ) : (
                                                <p className="font-semibold">
                                                    {/* दिनांक : {todayStr} */}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Second Row: Village/Taluka/District - Centered below */}
                                <div className="text-center mt-6 mb-4">
                                    <h2 className="text-2xl font-bold text-gray-900">
                                        मोजे: {proposalDetails.village_name || ""}, तालुका: {proposalDetails.taluka_name || ""}, जिल्हा: {proposalDetails.dist_name || ""}
                                    </h2>
                                </div>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="min-w-full border-collapse">
                                    <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                                        {/* Main Header Row */}
                                        <tr className="border-b-2 border-gray-300">
                                            {/* {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR) && ( */}
                                            {/* Data Entry */}
                                            {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR || userRole === USER_ROLES.DATA_ENTRY) && (
                                                <th rowSpan="2" className="px-4 py-4 text-center font-bold text-gray-700 bg-gray-50 min-w-[120px] no-print">
                                                    कृती
                                                </th>
                                            )}
                                            <th rowSpan="2" className="px-4 py-4 border-r border-gray-300 text-center font-bold text-gray-700 bg-white min-w-[60px]">
                                                अ.क्र
                                            </th>
                                            <th rowSpan="2" className="px-4 py-4 border-r border-gray-300 text-center font-bold text-gray-700 bg-white min-w-[100px]">
                                                भूमापन क्रमांक<br />(स.नं./ ग.नं.)
                                            </th>
                                            <th colSpan="3" className="px-4 py-3 border-r border-gray-300 text-center font-bold text-gray-700 bg-yellow-100 min-w-[240px]">
                                                भूमापन अभिलेखानुसार तपशिल
                                            </th>
                                            <th colSpan="3" className="px-4 py-3 border-r border-gray-300 text-center font-bold text-gray-700 bg-green-100 min-w-[320px]">
                                                प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल
                                            </th>
                                            <th colSpan="4" className="px-4 py-3 border-r border-gray-300 text-center font-bold text-gray-700 bg-purple-100 min-w-[320px]">
                                                प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल
                                            </th>
                                            <th colSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold text-gray-700 bg-orange-100 min-w-[200px]">
                                                कब्जेदार तपशील
                                            </th>
                                            <th colSpan="6" className="px-4 py-3 border-r border-gray-300 text-center font-bold text-gray-700 bg-pink-100 min-w-[480px]">
                                                संपादनाखालील क्षेत्रावरील इतर घटक
                                            </th>
                                            <th rowSpan="2" className="px-4 py-4 border-r border-gray-300 text-center font-bold text-gray-700 bg-gray-50 min-w-[120px]">
                                                गाव नकाशा व मोका परिस्थिती<br />यामध्ये तफावत असल्यास,<br />त्याची कायदेशीर कारणमिमांसा
                                            </th>
                                            <th rowSpan="2" className="px-4 py-4 border-r border-gray-300 text-center font-bold text-gray-700 bg-gray-50 min-w-[100px]">
                                                शेरा
                                            </th>
                                            {/* {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR) && (
                                                <th rowSpan="2" className="px-4 py-4 text-center font-bold text-gray-700 bg-gray-50 min-w-[120px] no-print">
                                                    कृती
                                                </th>
                                            )} */}
                                        </tr>

                                        {/* Sub Header Row */}
                                        <tr className="border-b border-gray-300">
                                            {/* Yellow  */}
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-yellow-50 text-xs">लागवडयोग्य<br />क्षेत्र (हे.आर.)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-yellow-50 text-xs">पोट खराब<br />क्षेत्र (हे.आर.)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-yellow-50 text-xs">एकूण क्षेत्र<br />(हे.आर.)</th>
                                            {/* Green */}
                                            {/* <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-green-50 text-xs">सव्र्व्हे नं. /<br />गट नंबर</th> */}
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-green-50 text-xs">अधिकार अभिलेखानुसार<br />भुधारकाचे नाव</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-green-50 text-xs">धारण केलेले<br />क्षेत्र (हे.आर.)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-green-50 text-xs">संपादनाखालील अंदाजे<br />क्षेत्र (हे.आर.)</th>
                                            {/* Purple */}
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-purple-50 text-xs">सर्व्हे नं. /<br />गट नंबर</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-purple-50 text-xs">लागवडयोग्य<br />क्षेत्र (हे.आर.)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-purple-50 text-xs">पोट खराब<br />क्षेत्र (हे.आर.)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-purple-50 text-xs">संपादनाखालील एकूण<br />क्षेत्र (हे.आर.)</th>
                                            {/* कब्जेदार तपशील */}
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-orange-50 text-xs">कब्जेदाराचे नाव</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-orange-50 text-xs">कब्जेदाराचे हक्क<br />संपादनाचे स्वरुप</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">फळझाडे<br />(प्रकार संख्या)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">वनझाडे<br />(प्रकार/ संख्या)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">विहीर / बोअरवेल<br />(प्रकार/ संख्या)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">पाईपलाईन<br />(मीटर)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">बांधकाम<br />(स्वरुप /तपशिल)</th>
                                            <th className="px-3 py-3 border-r border-gray-300 text-center font-semibold text-gray-600 bg-pink-50 text-xs">इतर<br /></th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                        {landAcquisitionData && landAcquisitionData.length > 0 ? (() => {
                                            let globalSr = 1; // Move serial counter outside to maintain continuity

                                            return landAcquisitionData.map((row, index) => {
                                                // Create array to hold all rows for this land acquisition record
                                                const allRows = [];

                                                // If there are owners, create rows for each owner
                                                if (row.owners && row.owners.length > 0) {
                                                    row.owners.forEach((owner, ownerIndex) => {
                                                        const isCurrentRowEditing = editingRowIndex === `${index}-${ownerIndex}`;
                                                        const isVerified = verifiedRows.has(owner.land_owner_id);

                                                        allRows.push(
                                                            <tr key={`owner-${owner.land_owner_id || `${index}-${ownerIndex}`}`}
                                                                className={`transition-colors border-b border-gray-200 ${Number(owner.is_active) === 0
                                                                    ? 'line-through opacity-60 bg-gray-100'
                                                                    : verifiedRows.has(owner.land_owner_id)
                                                                        ? 'bg-green-200'
                                                                        : 'hover:bg-gray-50'
                                                                    }`}
                                                                style={verifiedRows.has(owner.land_owner_id) ? {
                                                                    backgroundColor: '#A5D6A7',
                                                                } : {}}
                                                                onMouseEnter={(e) => {
                                                                    if (verifiedRows.has(owner.land_owner_id)) {
                                                                        e.currentTarget.style.backgroundColor = '#86efac';
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    if (verifiedRows.has(owner.land_owner_id)) {
                                                                        e.currentTarget.style.backgroundColor = '#bbf7d0';
                                                                    }
                                                                }}>

                                                                {/* Actions */}
                                                                {/* {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR) && ( */}
                                                                {/* Data Entry */}
                                                                {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR || userRole === USER_ROLES.DATA_ENTRY) && (
                                                                    <td className={`px-4 py-4 text-center ${isVerified ? '' : 'bg-gray-50'} no-print`}>
                                                                        <div className="flex items-center justify-center space-x-1">
                                                                            {(userRole === USER_ROLES.SURVEYOR || userRole===USER_ROLES.DATA_ENTRY) && (
                                                                                <>
                                                                                    {/* Verify Button */}
                                                                                    <button
                                                                                        onClick={() => handleRowVerification(owner.land_owner_id)}
                                                                                        className={`p-1.5 ${verifiedRows.has(owner.land_owner_id)
                                                                                            ? 'bg-green-600 hover:bg-green-700'
                                                                                            : 'bg-blue-600 hover:bg-blue-700'
                                                                                            } text-white rounded transition-colors`}
                                                                                        title={verifiedRows.has(owner.land_owner_id) ? "Verified" : "Verify"}
                                                                                    >
                                                                                        <Check className="h-3 w-3" />
                                                                                    </button>

                                                                                    {/* Edit Button */}
                                                                                    {!isCurrentRowEditing ? (
                                                                                        <button
                                                                                            onClick={() => handleSurveyorEditButtonClick(owner)}
                                                                                            className="p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                                                                                            title="संपादित करा"
                                                                                        >
                                                                                            <Edit className="h-3 w-3" />
                                                                                        </button>
                                                                                    ) : (
                                                                                        <>
                                                                                            <button
                                                                                                onClick={() => setEditingRowIndex(null)}
                                                                                                disabled={updating}
                                                                                                className="p-1.5 bg-green-100 hover:bg-green-700 disabled:bg-green-400 text-white rounded transition-colors"
                                                                                                title="जतन करा"
                                                                                            >
                                                                                                <Save className="h-3 w-3" />
                                                                                            </button>
                                                                                            <button
                                                                                                onClick={() => setEditingRowIndex(null)}
                                                                                                className="p-1.5 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
                                                                                                title="रद्द करा"
                                                                                            >
                                                                                                <X className="h-3 w-3" />
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            {userRole === USER_ROLES.LAO && Number(owner.is_active) !== 0 && (
                                                                                <div className="flex gap-2">
                                                                                    <td>
                                                                                        {editingRowIndex === owner.land_owner_id ? (
                                                                                            <button
                                                                                                onClick={handleUpdateMeasurement}
                                                                                                className="px-3 py-1 bg-green-600 text-white rounded flex items-center"
                                                                                            >
                                                                                                <Save className="h-4 w-4 mr-1" /> Save
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                onClick={() => handleLAOEditButtonClick(owner, owner.land_owner_id)}
                                                                                                className="px-3 py-1 bg-blue-600 text-white rounded flex items-center"
                                                                                            >
                                                                                                <Edit className="h-4 w-4 mr-1" /> Edit
                                                                                            </button>
                                                                                        )}
                                                                                    </td>

                                                                                    <button
                                                                                        onClick={() => handleDeleteRecord(owner)}
                                                                                        disabled={loading || Number(owner.is_active) === 0}
                                                                                        className={`p-1.5 ${Number(owner.is_active) === 0
                                                                                            ? 'bg-gray-400 cursor-not-allowed'
                                                                                            : 'bg-red-600 hover:bg-red-700'
                                                                                            } text-white rounded transition-colors`}
                                                                                        title="हटवा"
                                                                                    >
                                                                                        <Trash2 className="h-3 w-3" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                {/* Land Acquisition Details - Show for first owner only with rowspan */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-base font-bold text-blue-700 ${isVerified ? '' : 'bg-blue-25'}`}>
                                                                    {globalSr++}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 ${isVerified ? '' : 'bg-green-25'}`}>
                                                                    {owner.survey_no || row.survey_no || 'N/A'}
                                                                </td>
                                                                {/* yellow */}
                                                                {/* भूमापन अभिलेखानुसार तपशिल */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 ${isVerified ? '' : 'bg-green-25'}`}>
                                                                    {owner.owner_7_12_irrigable_area || '0'}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 ${isVerified ? '' : 'bg-green-25'}`}>
                                                                    {owner.owner_7_12_non_irrigable_area || '0'}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 ${isVerified ? '' : 'bg-green-25'}`}>
                                                                    {(parseFloat(owner.owner_7_12_irrigable_area || 0) + parseFloat(owner.owner_7_12_non_irrigable_area || 0)).toFixed(2)}
                                                                </td>


                                                                {/* Green */}
                                                                {/* प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल */}
                                                                {/* <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-semibold text-gray-800 bg-green-50">
                                                                    {owner.survey_no || '0'}
                                                                </td> */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 ${isVerified ? '' : 'bg-purple-50'}`}>
                                                                    {owner.owner_name || 'N/A'}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-purple-50'}`}>
                                                                    {owner.owner_total_area || '0'}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-purple-50'}`}>
                                                                    {owner.owner_aqr_area || '0'}
                                                                </td>

                                                                {/* Purple */}
                                                                {/* प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm font-semibold text-gray-800 ${isVerified ? '' : 'bg-purple-100'} border-2 border-purple-300`}>
                                                                    {owner.survey_no || '0'}
                                                                </td>

                                                                {/* <td className="px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 bg-orange-25">
                                                                    {owner.owner_irrigable_area || '0'}
                                                                </td> */}

                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-orange-25'}`}>
                                                                    {userRole === USER_ROLES.LAO && editingRowIndex === owner.land_owner_id ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            value={currentEditData.owner_irrigable_area || ''}
                                                                            onChange={(e) => handleEditInputChange("owner_irrigable_area", e.target.value)}
                                                                            placeholder="Irrigable Area"
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center bg-white"
                                                                        />
                                                                    ) : (
                                                                        <span>{owner.owner_irrigable_area || '0'}</span>
                                                                    )}
                                                                </td>
                                                                {/* <td className="px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 bg-orange-25">
                                                                    {owner.owner_non_irrigable_area || '0'}
                                                                </td> */}

                                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 bg-orange-25">
                                                                    {userRole === USER_ROLES.LAO && editingRowIndex === owner.land_owner_id ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            value={currentEditData.owner_non_irrigable_area || ''}
                                                                            onChange={(e) => handleEditInputChange("owner_non_irrigable_area", e.target.value)}
                                                                            placeholder="Non-Irrigable Area"
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center bg-white"
                                                                        />
                                                                    ) : (
                                                                        <span>{owner.owner_non_irrigable_area || '0'}</span>
                                                                    )}
                                                                </td>

                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-orange-25'}`}>
                                                                    {(
                                                                        parseFloat(owner.owner_irrigable_area || 0) +
                                                                        parseFloat(owner.owner_non_irrigable_area || 0)
                                                                    ).toFixed(2)}
                                                                </td>


                                                                {/* Orange-pink */}
                                                                {/* कब्जेदार तपशील */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-orange-25'}`}>
                                                                    {owner.actual_occupant || '0'}
                                                                </td>
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-orange-25'}`}>
                                                                    {owner.nature_of_owner || '-'}
                                                                </td>

                                                                {/* संपादनाखालील क्षेत्रावरील इतर घटक */}
                                                                {/* मालमत्ता तपशील Tress फळझाडे*/}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_tree || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs space-y-1">
                                                                            {owner.tree && owner.tree.length > 0 ? (
                                                                                owner.tree
                                                                                    .filter((t) => t.tree_type_name1 === "फळझाडे") // फक्त फळझाडे
                                                                                    .map((t, i) => (
                                                                                        <div key={i} className="flex justify-between">
                                                                                            <span className="font-medium">{t.tree_type_name}</span>
                                                                                            <span>- {t.tree_count}</span>
                                                                                        </div>
                                                                                    ))
                                                                            ) : (
                                                                                <span className="text-gray-700">{owner.no_of_tree || '0'}</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* वनझाडे */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_tree || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs space-y-1">
                                                                            {owner.tree && owner.tree.length > 0 ? (
                                                                                owner.tree
                                                                                    .filter((t) => t.tree_type_name1 === "वनझाडे") // फक्त वनझाडे
                                                                                    .map((t, i) => (
                                                                                        <div key={i} className="flex justify-between">
                                                                                            <span className="font-medium">{t.tree_type_name}</span>
                                                                                            <span>- {t.tree_count}</span>
                                                                                        </div>
                                                                                    ))
                                                                            ) : (
                                                                                <span className="text-gray-700">{owner.no_of_tree || '0'}</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* well/borewell */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_borewell || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs text-gray-700 space-y-1">
                                                                            {(owner.well && owner.well.length > 0) || (owner.borewell && owner.borewell.length > 0) ? (
                                                                                <div className="space-y-1">
                                                                                    {/* Wells */}
                                                                                    {owner.well && owner.well.length > 0 &&
                                                                                        owner.well.map((w, i) => (
                                                                                            <div key={`well-${i}`}>
                                                                                                विहीर ({w.Property_length || 0}m* {w.Property_depth || 0}m)
                                                                                            </div>
                                                                                        ))
                                                                                    }

                                                                                    {/* Borewells */}
                                                                                    {owner.borewell && owner.borewell.length > 0 &&
                                                                                        owner.borewell.map((b, i) => (
                                                                                            <div key={`bore-${i}`}>
                                                                                                बोअरवेल ({b.Property_depth || 0}m)
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            ) : (
                                                                                <span>0</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Pipeline */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_pipeline || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs text-gray-700 space-y-1">
                                                                            {(owner.pipeline && owner.pipeline.length > 0) ? (
                                                                                <div className="space-y-1">

                                                                                    {owner.pipeline.map((p, i) => (
                                                                                        <div key={`pipeline-${i}`}>
                                                                                            पाईपलाईन ({p.Property_length || 0}m*{p.Property_width || 0}m)
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            ) : (
                                                                                <span>0</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Home Tinshed */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_home || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs space-y-1">
                                                                            {(owner.home && owner.home.length > 0) || (owner["tinshed/godown"] && owner["tinshed/godown"].length > 0) ? (
                                                                                <>
                                                                                    {/* Homes */}
                                                                                    {owner.home && owner.home.length > 0 &&
                                                                                        owner.home.map((h, i) => {
                                                                                            const floorName =
                                                                                                h.house_floor_no
                                                                                                    ?.replace(/_/g, ' ')
                                                                                                    ?.replace(/\b\w/g, (l) => l.toUpperCase()) || 'Floor';

                                                                                            return (
                                                                                                <div key={`home-${i}`} className="text-gray-800">
                                                                                                    घर ({floorName}
                                                                                                    ({h.Property_width}m × {h.Property_length}m))
                                                                                                </div>
                                                                                            );
                                                                                        })
                                                                                    }

                                                                                    {/* Tinshed/Godown */}
                                                                                    {owner["tinshed/godown"] && owner["tinshed/godown"].length > 0 &&
                                                                                        owner["tinshed/godown"].map((w, i) => (
                                                                                            <div key={`tinshed-${i}`} className="text-gray-800">
                                                                                                टिनशेड ({w.Property_length || 0}m * {w.Property_width || 0}m)
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </>
                                                                            ) : (
                                                                                <span className="text-gray-700">{owner.no_of_home || "0"}</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Other - wirefencing, farmpond, other */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-center text-sm text-gray-800 ${isVerified ? '' : 'bg-pink-50'}`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            defaultValue={owner.no_of_other_asset || '0'}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 text-center"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-gray-700 space-y-1">
                                                                            {(owner.wirefencing && owner.wirefencing.length > 0) || (owner.farmpond && owner.farmpond.length > 0) || (owner.other && owner.other.length > 0) ? (
                                                                                <div className="space-y-1">
                                                                                    {/* wirefencing */}
                                                                                    {owner.wirefencing && owner.wirefencing.length > 0 &&
                                                                                        owner.wirefencing.map((w, i) => (
                                                                                            <div key={`wirefencing-${i}`}>
                                                                                                wirefencing ({w.Property_length || 0}m)
                                                                                            </div>
                                                                                        ))
                                                                                    }

                                                                                    {/* farmpond */}
                                                                                    {owner.farmpond && owner.farmpond.length > 0 &&
                                                                                        owner.farmpond.map((w, i) => (
                                                                                            <div key={`farmpond-${i}`}>
                                                                                                farmpond ({w.Property_length || 0}m * {w.Property_width}m * {w.Property_depth || 0}m)
                                                                                            </div>
                                                                                        ))
                                                                                    }

                                                                                    {/* Other assets can be added here */}
                                                                                    {owner.other && owner.other.length > 0 &&
                                                                                        owner.other.map((w, i) => (
                                                                                            <div key={`wire-${i}`}>
                                                                                                {w.construction_type || 0}-{w.Property_count}
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            ) : (
                                                                                <span>0</span>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Legal Reasons - only show for first owner */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-left text-sm ${isVerified ? '' : 'bg-gray-50'} align-top`}>                                                                    <div className="text-xs text-gray-700 max-w-32 break-words">
                                                                    {owner.remarks || ''}
                                                                </div>
                                                                </td>

                                                                {/* Remarks */}
                                                                <td className={`px-4 py-4 border-r border-gray-300 text-left text-sm ${isVerified ? '' : 'bg-gray-50'} align-top`}>
                                                                    {isCurrentRowEditing ? (
                                                                        <textarea
                                                                            defaultValue={owner.remarks || ''}
                                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm resize-none focus:ring-2 focus:ring-blue-500"
                                                                            rows="2"
                                                                        />
                                                                    ) : (
                                                                        <div className="text-xs max-w-32 break-words">
                                                                            {owner.justification || ''}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {/* Actions
                                                                {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR) && (
                                                                    <td className="px-4 py-4 text-center bg-gray-50 no-print">
                                                                        <div className="flex items-center justify-center space-x-1">
                                                                            {userRole === USER_ROLES.SURVEYOR && (
                                                                                <>
                                                                                    {!isCurrentRowEditing ? (
                                                                                        <button
                                                                                            onClick={() => handleSurveyorEditButtonClick(owner)}
                                                                                            className="p-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                                                                                            title="संपादित करा"
                                                                                        >
                                                                                            <Edit className="h-3 w-3" />
                                                                                        </button>
                                                                                    ) : (
                                                                                        <>
                                                                                            <button
                                                                                                onClick={() => setEditingRowIndex(null)}
                                                                                                disabled={updating}
                                                                                                className="p-1.5 bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white rounded transition-colors"
                                                                                                title="जतन करा"
                                                                                            >
                                                                                                <Save className="h-3 w-3" />
                                                                                            </button>
                                                                                            <button
                                                                                                onClick={() => setEditingRowIndex(null)}
                                                                                                className="p-1.5 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
                                                                                                title="रद्द करा"
                                                                                            >
                                                                                                <X className="h-3 w-3" />
                                                                                            </button>
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            {userRole === USER_ROLES.LAO && Number(owner.is_active) !== 0 && (
                                                                                <div className="flex gap-2">
                                                                                    <td>
                                                                                        {editingRowIndex === owner.land_owner_id ? (
                                                                                            <button
                                                                                                onClick={handleUpdateMeasurement}
                                                                                                className="px-3 py-1 bg-green-600 text-white rounded flex items-center"
                                                                                            >
                                                                                                <Save className="h-4 w-4 mr-1" /> Save
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                onClick={() => handleLAOEditButtonClick(owner, owner.land_owner_id)}
                                                                                                className="px-3 py-1 bg-blue-600 text-white rounded flex items-center"
                                                                                            >
                                                                                                <Edit className="h-4 w-4 mr-1" /> Edit
                                                                                            </button>
                                                                                        )}
                                                                                    </td>


                                                                                    <button
                                                                                        onClick={() => handleDeleteRecord(owner)}
                                                                                        disabled={loading || Number(owner.is_active) === 0}
                                                                                        className={`p-1.5 ${Number(owner.is_active) === 0
                                                                                            ? 'bg-gray-400 cursor-not-allowed'
                                                                                            : 'bg-red-600 hover:bg-red-700'
                                                                                            } text-white rounded transition-colors`}
                                                                                        title="हटवा"
                                                                                    >
                                                                                        <Trash2 className="h-3 w-3" />
                                                                                    </button>

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                )} */}
                                                            </tr>
                                                        );
                                                    });
                                                } else {
                                                    // If no owners, show just the land acquisition data
                                                    allRows.push(
                                                        <tr key={`land-${row.LandAcquisition_id || index}`} className="hover:bg-gray-50 transition-colors border-b border-gray-200">
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-bold text-blue-700">
                                                                {globalSr++}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-semibold text-blue-700">
                                                                {row.survey_no || 'N/A'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 bg-yellow-25">
                                                                {row.irrigable_area || '0'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 bg-yellow-25">
                                                                {row.non_irrigable_area || '0'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-semibold text-gray-800 bg-yellow-50">
                                                                {row.total_area || '0'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 bg-green-25">
                                                                {row.survey_no || 'N/A'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 bg-green-25">
                                                                {row.landholder_name || 'N/A'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-medium text-gray-800 bg-green-25">
                                                                {row.irrigable_area || '0'}
                                                            </td>
                                                            <td className="px-4 py-4 border-r border-gray-300 text-center text-sm font-semibold text-gray-800 bg-green-50">
                                                                {row.aqr_area || row.total_area || '0'}
                                                            </td>
                                                            <td colSpan="11" className="px-4 py-4 text-center text-sm text-gray-500 bg-gray-25">
                                                                कब्जेदार माहिती उपलब्ध नाही
                                                            </td>
                                                            {(userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR) && (
                                                                <td className="px-4 py-4 text-center bg-gray-50">
                                                                    <span className="text-xs text-gray-500">कोई कार्रवाई नहीं</span>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );
                                                }

                                                return allRows;
                                            }).flat();
                                        })() : (
                                            <tr>
                                                <td colSpan={userRole === USER_ROLES.LAO || userRole === USER_ROLES.SURVEYOR ? "21" : "20"} className="px-6 py-12 text-center text-gray-500">
                                                    <div className="flex flex-col items-center">
                                                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                                            <FileText className="w-8 h-8 text-gray-400" />
                                                        </div>
                                                        <p className="text-lg font-medium">कोणताही डेटा उपलब्ध नाही</p>
                                                        <p className="text-sm text-gray-400 mt-2">कृपया प्रथम भूमापन डेटा जोडा</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* ✅ TOTAL ROW */}
                                        {landAcquisitionData && landAcquisitionData.length > 0 && (() => {
                                            // flatten all owners
                                            const allOwners = landAcquisitionData.flatMap(r => r.owners || []);
                                            // filter only active owners
                                            const activeOwners = allOwners.filter(o => Number(o.is_active) === 1);

                                            return (
                                                <tr className="bg-gray-100 font-bold">
                                                    {/* Actions col (खाली) */}
                                                    <td></td>
                                                    {/* Sr.No col (खાલી) */}
                                                    <td></td>
                                                    {/* Survey No col (खાલી) */}
                                                    <td>Total</td>

                                                    {/* भूमापन अभिलेखानुसार लागवडयोग्य */}
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_7_12_irrigable_area || 0), 0).toFixed(2)}
                                                    </td>
                                                    {/* भूमापन अभिलेखानुसार पोट खराब */}
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_7_12_non_irrigable_area || 0), 0).toFixed(2)}
                                                    </td>
                                                    {/* भूमापन अभिलेखानुसार एकूण */}
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce(
                                                            (sum, o) =>
                                                                sum +
                                                                (Number(o.owner_7_12_irrigable_area || 0) +
                                                                    Number(o.owner_7_12_non_irrigable_area || 0)),
                                                            0
                                                        ).toFixed(2)}
                                                    </td>

                                                    {/* प्रस्तावानुसार धारण केलेले */}
                                                    <td></td> {/* owner_name skip */}
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_total_area || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_aqr_area || 0), 0).toFixed(2)}
                                                    </td>

                                                    {/* प्रत्यक्ष मोजणीअंती */}
                                                    <td></td> {/* survey_no skip */}
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_irrigable_area || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce((sum, o) => sum + Number(o.owner_non_irrigable_area || 0), 0).toFixed(2)}
                                                    </td>
                                                    <td className="border px-2 py-1 text-center">
                                                        {activeOwners.reduce(
                                                            (sum, o) =>
                                                                sum +
                                                                (Number(o.owner_irrigable_area || 0) +
                                                                    Number(o.owner_non_irrigable_area || 0)),
                                                            0
                                                        ).toFixed(2)}
                                                    </td>

                                                    {/* बाकी कब्जेदार/झાડे/इत्यादी कॉलમ्स skip */}
                                                    <td colSpan={8}></td>
                                                </tr>
                                            );
                                        })()}

                                    </tbody>
                                </table>
                            </div>

                            {/* Footer Section */}
                            <div className="mt-16 px-5 py-5">

                                {/* 7 Signatures in one row */}
                                <div className="grid grid-cols-7 gap-4 text-center mb-12 sign-space">

                                    {/* तलाठी */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">ग्राम महसूल अधिकारी</p>
                                    </div>

                                    {/* वनरक्षक */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">वनरक्षक</p>
                                    </div>

                                    {/* कृषि सहायक / मंडळ अधिकारी (कृषि) */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">
                                            कृषि सहायक / मंडळ अधिकारी (कृषि)
                                        </p>
                                    </div>

                                    {/* संपादन संस्थेचा प्रतिनिधी */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">
                                            संपादन संस्थेचा प्रतिनिधी
                                        </p>
                                    </div>

                                    {/* भूकरमापक */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">भूकरमापक</p>
                                    </div>

                                    {/* छाननी लिपीक */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">छाननी लिपीक</p>
                                    </div>

                                    {/* उप-अधीक्षक भूमि अभिलेख */}
                                    <div>
                                        <p className="text-sm font-semibold text-gray-800">
                                            उप-अधीक्षक भूमि अभिलेख
                                        </p>
                                    </div>
                                </div>

                                {/* Notes Section (below, aligned left) */}
                                {/* <div className="mt-10 text-left">
                                    <ul className="list-inside text-sm font-semibold text-gray-800 space-y-2">
                                        <li>१. सर्व आकडे इंग्रजीत दर्शविण्यात यावेत.</li>
                                        <li>२. क्षेत्र दशांश पध्दतीने दर्शविण्यात यावे. उदा. 1.22, 1.20, 1.06 याप्रमाणे</li>
                                        <li>३. सर्व नोंदी स.नं. / ग.नं. च्या अनुक्रमाने घेण्यात याव्यात.</li>
                                        <li>४. अहवालात कोणत्याही स्वरुपाची खोडतोड / उपरीलेखन करु नये. प्रत्येक पानावर स्वाक्षऱ्या घेण्यात याव्या.</li>
                                        <li>५. शेरा स्तंभामध्ये मोघम व संभ्रम निर्माण करणारी विधाने करुन नयेत.</li>
                                    </ul>
                                </div> */}

                            </div>
                        </div>
                    </div>

                    {/* Table Summary Footer */}
                    {/* {landAcquisitionData && landAcquisitionData.length > 0 && (
                        <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-t-2 border-gray-300 p-4">
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                                <div className="bg-white rounded-lg p-3 border">
                                    <div className="text-gray-600 font-medium">एकूण भूमि नोंदी</div>
                                    <div className="text-xl font-bold text-blue-600">{landAcquisitionData.length}</div>
                                </div>
                                <div className="bg-white rounded-lg p-3 border">
                                    <div className="text-gray-600 font-medium">एकूण कब्जेदार</div>
                                    <div className="text-xl font-bold text-green-600">
                                        {landAcquisitionData.reduce((total, land) =>
                                            total + (land.owners ? land.owners.length : 0), 0
                                        )}
                                    </div>
                                </div>
                                <div className="bg-white rounded-lg p-3 border">
                                    <div className="text-gray-600 font-medium">एकूण क्षेत्र</div>
                                    <div className="text-xl font-bold text-purple-600">
                                        {landAcquisitionData.reduce((total, land) =>
                                            total + parseFloat(land.total_area || 0), 0
                                        ).toFixed(2)} हे.आर.
                                    </div>
                                </div>
                                <div className="bg-white rounded-lg p-3 border">
                                    <div className="text-gray-600 font-medium">स्थिती</div>
                                    <div className="text-sm font-medium text-orange-600">सक्रिय</div>
                                </div>
                            </div>
                        </div>
                    )} */}
                </div>

            </div>

            {/* Confirmation Dialog */}
            {/* {showconfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">{translations[language]?.confirmDownload}</h3>
                        <p className="text-gray-600 mb-6">{translations[language]?.confirmDownloadMessage}</p>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-lg transition-colors"
                            >
                                {translations[language]?.cancel}
                            </button>
                            <button
                                onClick={handleDownloadPDF}
                                className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
                            >
                                {translations[language]?.download}
                            </button>
                        </div>
                    </div>
                </div>

            )} */}

            {/* Surveyor Second Assignment Confirmation Modal */}
            {showSurveyorConfirmModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                        <div className="flex items-center mb-4">
                            <div className="bg-amber-100 p-2 rounded-full mr-3">
                                <svg className="w-6 h-6 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800">{translations[language].ReassignToSurveyor}</h3>
                        </div>
                        <p className="text-sm text-gray-600 mb-6">
                            {translations[language].ReassignConfirmation}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                                onClick={() => setShowSurveyorConfirmModal(false)}
                            >
                                {translations[language].Cancel}
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                onClick={async () => {
                                    setShowSurveyorConfirmModal(false);
                                    setShowSendToSurveyorModal(true);
                                    await fetchUsers(); // Fetch Surveyors
                                }}
                            >
                                {translations[language].YesReassign}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Collapsible Filter Panel */}
            {showFilterPanel && (
                <div className="bg-white border-b border-gray-200 shadow-sm">
                    <div className="container mx-auto px-6 py-6">
                        <div className="space-y-6">
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                                {/* Filter Mode Selection */}
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-1 bg-gray-100 rounded-xl p-1.5 shadow-inner">
                                        <button
                                            onClick={() => setFilterMode('location')}
                                            className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'location'
                                                ? 'bg-white text-blue-600 shadow-sm'
                                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                                }`}
                                        >
                                            <MapPin className="h-4 w-4" />
                                            <span>{translations[language].FilterByLocation}</span>
                                        </button>
                                        <button
                                            onClick={() => setFilterMode('all')}
                                            className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'all'
                                                ? 'bg-white text-blue-600 shadow-sm'
                                                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                                                }`}
                                        >
                                            <Globe className="h-4 w-4" />
                                            <span>{translations[language].AllRecords}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Location Filters - Only show when location mode is selected */}
                            {filterMode === 'location' && (
                                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                                    <div className="space-y-4">
                                        <div className="flex items-center">
                                            <MapPin className="h-5 w-5 text-blue-600 mr-2" />
                                            <h3 className="text-lg font-semibold text-gray-800">{translations[language].SelectLocation}</h3>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            {/* District Dropdown */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language].District}
                                                </label>
                                                <select
                                                    value={selectedDistrict}
                                                    onChange={handleDistrictChange}
                                                    disabled={loadingDistricts}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingDistricts ? <span>{translations[language].LoadingDistricts}</span> : <span>{translations[language].SelectDistrict}</span>}
                                                    </option>
                                                    {districts.map((district, index) => (
                                                        <option key={district.dist_name || index} value={district.dist_name}>
                                                            {district.dist_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Taluka Dropdown */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language].Taluka}
                                                </label>
                                                <select
                                                    value={selectedTaluka}
                                                    onChange={handleTalukaChange}
                                                    disabled={!selectedDistrict || loadingTalukas}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingTalukas ? <span>{translations[language].LoadingTalukas}</span> : <span>{translations[language].SelectTaluka}</span>}
                                                    </option>
                                                    {talukas.map((taluka, index) => (
                                                        <option key={taluka.taluka_name || index} value={taluka.taluka_name}>
                                                            {taluka.taluka_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Village Dropdown */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {translations[language].Village}
                                                </label>
                                                <select
                                                    value={selectedVillage}
                                                    onChange={handleVillageChange}
                                                    disabled={!selectedTaluka || loadingVillages}
                                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                                                >
                                                    <option value="">
                                                        {loadingVillages ? <span>{translations[language].LoadingVillages}</span> : <span>{translations[language].SelectVillage}</span>}
                                                    </option>
                                                    {villages.map((village, index) => (
                                                        <option key={village.village_name || index} value={village.village_name}>
                                                            {village.village_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {filterMode === 'location' && !selectedDistrict && (
                                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                                                <p className="text-sm text-amber-700">
                                                    {translations[language].SelectDistrictNote}
                                                </p>
                                            </div>
                                        )}
                                        {filterMode === 'location' && selectedDistrict && (
                                            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                                                <p className="text-sm text-green-700 flex items-center">
                                                    <span className="mr-2">✓</span>
                                                    {translations[language].ShowingDataFor}: {getCurrentLocationDescription()}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* All Records Info */}
                            {filterMode === 'all' && (
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <div className="ml-3">
                                            <p className="text-sm text-blue-700">
                                                {translations[language].ShowingAllMeasurements}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Show message when filter mode is location but selection is incomplete */}
            {filterMode === 'location' && !selectedDistrict && (
                <div className="mt-6 text-center py-12">
                    <div className="max-w-md mx-auto">
                        <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                        <p className="text-gray-500 text-lg font-medium mb-2">{translations[language].DistrictSelectionRequired}</p>
                        <p className="text-gray-400 text-sm">{translations[language].DistrictSelectionNote}</p>
                    </div>
                </div>
            )}

            {/* handleSendBackToLAO */}
            {/* Send Back to LAO Modal */}
            {showSendBackToLAOModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <div className="flex justify-between items-center mb-6">
                                            <h3 className="text-xl font-semibold text-gray-800">Send Back to LAO Officer</h3>
                                            <button
                                                onClick={() => setShowSendBackToLAOModal(false)}
                                                className="text-gray-400 hover:text-gray-600"
                                            >
                                                <X className="h-6 w-6" />
                                            </button>
                                        </div> */}

                            <div className="space-y-4">
                                {/* Project Info */}
                                {/* {(() => {
                                          const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                                          return (
                                            <div className="p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                                              <p className="text-sm text-yellow-800">
                                                <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                                              </p>
                                              <p className="text-xs text-yellow-600">
                                                {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                                              </p>
                                              <p className="text-xs text-yellow-600 mt-1 font-medium">
                                                ⚠️ Sending verified measurements back to LAO for review
                                              </p>
                                              </div>
                                              );
                                              })()} */}

                                {/* <div className="p-3 bg-blue-50 rounded-lg">
                                                <p className="text-sm text-blue-800">
                                                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                                                </p>
                                                <p className="text-xs text-blue-600">
                                                    {translations[language].ID}: {currentProjectId}
                                                </p>
                                                <p className="text-xs text-yellow-600 mt-1 font-medium">
                                                    ⚠️ Sending verified measurements back to LAO for review
                                                </p>
                                            </div> */}

                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].SelectLAOOfficer} *
                                    </label>
                                    <select
                                        value={selectedUser}
                                        onChange={(e) => setSelectedUser(e.target.value)}
                                        disabled={loadingUsers}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                                    >
                                        <option value="">
                                            {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                        </option>
                                        {users.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].Remarks}
                                    </label>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                                        placeholder="Enter reason for sending back to LAO..."
                                    />
                                </div>


                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument} *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocument(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocument && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    {translations[language]?.Selected}: {selectedDocument.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocument.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocument?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocument);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleViewDocument(
                                                                uploadStatus === 'success' ? selectedSignDocument : selectedDocument
                                                            )}
                                                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                        >
                                                            <Eye className="h-3 w-3" />
                                                            {translations[language]?.View}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                            {/* Upload status messages */}
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document Signed Successfully
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendBackToLAOModal(false)
                                        setSelectedDocument(null); // Reset the selected document file
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToLAO}
                                >
                                    {translations[language].Cancel}
                                </button>
                                <button
                                    onClick={handleSendBackToLAO}
                                    disabled={sendingToLAO || !selectedUser || !selectedDocument}
                                    className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToLAO ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language].Sending}
                                        </>
                                    ) : (
                                        <>
                                            <ArrowLeft className="mr-2 h-4 w-4" />
                                            {translations[language].CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* SignaturePad Modal */}
                    {showSignaturePad && pdfForSigning && (
                        <SignaturePad
                            pdfFile={pdfForSigning}
                            onSign={(signaturesArray) => {
                                setShowSignaturePad(false);
                                signDocument(pdfForSigning, signaturesArray).then(() => {
                                    setPdfForSigning(null);
                                });
                            }}
                            onCancel={() => {
                                setShowSignaturePad(false);
                                setPdfForSigning(null);
                            }}
                        />
                    )}
                </div>
            )}

            {/* handleSendToSurveyor */}
            {/* Send to Surveyor Modal */}
            {showSendToSurveyorModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-semibold text-gray-800">{translations[language].SendToSurveyor}</h3>
                                <button
                                    onClick={() => setShowSendToSurveyorModal(false)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <X className="h-6 w-6" />
                                </button>
                            </div> */}

                            <div className="space-y-4">
                                {/* Project Info */}
                                {/* {(() => {
                              const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                              return (
                                <div className="p-3 bg-blue-50 rounded-lg">
                                  <p className="text-sm text-blue-800">
                                    <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                                  </p>
                                  <p className="text-xs text-blue-600">
                                    {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                                  </p>
                                </div>
                              );
                            })()} */}
                                {/* <div className="p-3 bg-blue-50 rounded-lg">
                                    <p className="text-sm text-blue-800">
                                        <strong>{translations[language].Project}:</strong> {currentProjectName}
                                    </p>
                                    <p className="text-xs text-blue-600">
                                        {translations[language].ID}: {currentProjectId}
                                    </p>
                                </div> */}


                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].SelectUserSurveyor} *
                                    </label>
                                    <select
                                        value={selectedUser}
                                        onChange={(e) => setSelectedUser(e.target.value)}
                                        disabled={loadingUsers}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                        </option>
                                        {users.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].Remarks}
                                    </label>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder={translations[language].EnterRemarks}
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument} *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocument(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocument && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    {translations[language]?.Selected}: {selectedDocument.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocument.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocument?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocument);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleViewDocument(
                                                                uploadStatus === 'success' ? selectedSignDocument : selectedDocument
                                                            )}
                                                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                        >
                                                            <Eye className="h-3 w-3" />
                                                            {translations[language]?.View}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                            {/* Upload status messages */}
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document Signed Successfully
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendToSurveyorModal(false)
                                        setSelectedDocument(null); // Reset the selected document file
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToLAO}
                                >
                                    {translations[language].Cancel}
                                </button>
                                <button
                                    onClick={handleSendToSurveyor}
                                    disabled={sendingToLAO || !selectedUser || !selectedDocument}
                                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToLAO ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language].Sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language].CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* SignaturePad Modal */}
                    {showSignaturePad && pdfForSigning && (
                        <SignaturePad
                            pdfFile={pdfForSigning}
                            onSign={(signaturesArray) => {
                                setShowSignaturePad(false);
                                signDocument(pdfForSigning, signaturesArray).then(() => {
                                    setPdfForSigning(null);
                                });
                            }}
                            onCancel={() => {
                                setShowSignaturePad(false);
                                setPdfForSigning(null);
                            }}
                        />
                    )}
                </div>
            )}

            {/* handleSendBackToDSLR */}
            {/* Send Back to DSLR Modal */}
            {showSendBackToDSLRModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            {/* <div className="flex justify-between items-center mb-6">
                                           <h3 className="text-xl font-semibold text-gray-800">Send Back to DSLR Officer</h3>
                                           <button
                                               onClick={() => setShowSendBackToDSLRModal(false)}
                                               className="text-gray-400 hover:text-gray-600"
                                           >
                                               <X className="h-6 w-6" />
                                           </button>
                                       </div> */}

                            <div className="space-y-4">
                                {/* Project Info */}
                                {/* {(() => {
                                         const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                                         return (
                                           <div className="p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                                             <p className="text-sm text-yellow-800">
                                               <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                                             </p>
                                             <p className="text-xs text-yellow-600">
                                               {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                                             </p>
                                             <p className="text-xs text-yellow-600 mt-1 font-medium">
                                               ⚠️ Sending completed measurements back to DSLR for review
                                             </p>
                                             </div>
                                             );
                                             })()} */}

                                {/* <div className="p-3 bg-blue-50 rounded-lg">
                                               <p className="text-sm text-blue-800">
                                                   <strong>{translations[language].Project}:</strong> {currentProjectName}
                                               </p>
                                               <p className="text-xs text-blue-600">
                                                   {translations[language].ID}: {currentProjectId}
                                               </p>
                                               <p className="text-xs text-yellow-600 mt-1 font-medium">
                                                   ⚠️ Sending completed measurements back to DSLR for review
                                               </p>
           
                                           </div> */}
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].SelectUserDSLR} *
                                    </label>
                                    <select
                                        value={selectedUser}
                                        onChange={(e) => setSelectedUser(e.target.value)}
                                        disabled={loadingUsers}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                                    >
                                        <option value="">
                                            {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                        </option>
                                        {users.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language].Remarks}
                                    </label>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                                        placeholder="Enter reason for sending back to DSLR..."
                                    />
                                </div>
                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.UploadDocument} *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocument(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocument && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    {translations[language]?.Selected}: {selectedDocument.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocument.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocument?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocument);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleViewDocument(
                                                                uploadStatus === 'success' ? selectedSignDocument : selectedDocument
                                                            )}
                                                            className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                        >
                                                            <Eye className="h-3 w-3" />
                                                            {translations[language]?.View}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                            {/* Upload status messages */}
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document Signed Successfully
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendBackToDSLRModal(false)
                                        setSelectedDocument(null); // Reset the selected document file
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToLAO}
                                >
                                    {translations[language].Cancel}
                                </button>
                                <button
                                    onClick={handleSendBackToDSLR}
                                    disabled={sendingToLAO || !selectedUser || !selectedDocument}
                                    className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToLAO ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language].Sending}
                                        </>
                                    ) : (
                                        <>
                                            <ArrowLeft className="mr-2 h-4 w-4" />
                                            {translations[language].CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* SignaturePad Modal */}
                    {showSignaturePad && pdfForSigning && (
                        <SignaturePad
                            pdfFile={pdfForSigning}
                            onSign={(signaturesArray) => {
                                setShowSignaturePad(false);
                                signDocument(pdfForSigning, signaturesArray).then(() => {
                                    setPdfForSigning(null);
                                });
                            }}
                            onCancel={() => {
                                setShowSignaturePad(false);
                                setPdfForSigning(null);
                            }}
                        />
                    )}
                </div>
            )}

            {/* handleSendToAgency */}
            {/* Send to Agency Modal */}
            {showSendToAgencyModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="space-y-6">
                                {/* Agriculture Agency Section */}
                                <div className="border rounded-lg p-4 bg-gray-50">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Agriculture {translations[language].SelectConcernValuerUser} *
                                            </label>
                                            <select
                                                value={selectedUsers.agriculture}
                                                onChange={(e) => setSelectedUsers({ ...selectedUsers, agriculture: e.target.value })}
                                                disabled={loadingUsers}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                                </option>
                                                {agricultureUsers.map((user) => (
                                                    <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                        {user.full_name || user.user_name} ({user.usr_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Agriculture Document *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setSelectedDocuments({ ...selectedDocuments, agriculture: e.target.files[0] })}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />
                                            {selectedDocuments.agriculture && (
                                                <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
                                                    <p className="text-xs text-green-700 truncate">
                                                        {selectedDocuments.agriculture.name} ({(selectedDocuments.agriculture.size / 1024 / 1024).toFixed(2)} MB)
                                                        {signedDocuments.agriculture && <span className="ml-2 text-purple-600 font-semibold">✓ SIGNED</span>}
                                                    </p>
                                                    {selectedDocuments.agriculture.type === 'application/pdf' && (
                                                        <div className="flex gap-1 mt-1">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setPdfForSigning(selectedDocuments.agriculture);
                                                                    setCurrentSigningAgency('agriculture');
                                                                    setShowSignaturePad(true);
                                                                }}
                                                                disabled={signedDocuments.agriculture !== null}
                                                                className={`px-2 py-1 text-xs rounded ${signedDocuments.agriculture
                                                                    ? 'bg-gray-400 text-white cursor-not-allowed'
                                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                                    }`}
                                                            >
                                                                {signedDocuments.agriculture ? 'Signed' : 'Sign'}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(signedDocuments.agriculture || selectedDocuments.agriculture)}
                                                                className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                                            >
                                                                View
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Forest Agency Section */}
                                <div className="border rounded-lg p-4 bg-gray-50">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Forest {translations[language].SelectConcernValuerUser} *
                                            </label>
                                            <select
                                                value={selectedUsers.forest}
                                                onChange={(e) => setSelectedUsers({ ...selectedUsers, forest: e.target.value })}
                                                disabled={loadingUsers}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                                </option>
                                                {forestUsers.map((user) => (
                                                    <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                        {user.full_name || user.user_name} ({user.usr_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Forest Document *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setSelectedDocuments({ ...selectedDocuments, forest: e.target.files[0] })}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />
                                            {selectedDocuments.forest && (
                                                <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
                                                    <p className="text-xs text-green-700 truncate">
                                                        {selectedDocuments.forest.name} ({(selectedDocuments.forest.size / 1024 / 1024).toFixed(2)} MB)
                                                        {signedDocuments.forest && <span className="ml-2 text-purple-600 font-semibold">✓ SIGNED</span>}
                                                    </p>
                                                    {selectedDocuments.forest.type === 'application/pdf' && (
                                                        <div className="flex gap-1 mt-1">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setPdfForSigning(selectedDocuments.forest);
                                                                    setCurrentSigningAgency('forest');
                                                                    setShowSignaturePad(true);
                                                                }}
                                                                disabled={signedDocuments.forest !== null}
                                                                className={`px-2 py-1 text-xs rounded ${signedDocuments.forest
                                                                    ? 'bg-gray-400 text-white cursor-not-allowed'
                                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                                    }`}
                                                            >
                                                                {signedDocuments.forest ? 'Signed' : 'Sign'}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(signedDocuments.forest || selectedDocuments.forest)}
                                                                className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                                            >
                                                                View
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Other/TP Agency Section */}
                                <div className="border rounded-lg p-4 bg-gray-50">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Other {translations[language].SelectConcernValuerUser} *
                                            </label>
                                            <select
                                                value={selectedUsers.tp}
                                                onChange={(e) => setSelectedUsers({ ...selectedUsers, tp: e.target.value })}
                                                disabled={loadingUsers}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                                                </option>
                                                {tpUsers.map((user) => (
                                                    <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                        {user.full_name || user.user_name} ({user.usr_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Other Document *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setSelectedDocuments({ ...selectedDocuments, tp: e.target.files[0] })}
                                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />
                                            {selectedDocuments.tp && (
                                                <div className="mt-2 p-2 bg-green-50 rounded border border-green-200">
                                                    <p className="text-xs text-green-700 truncate">
                                                        {selectedDocuments.tp.name} ({(selectedDocuments.tp.size / 1024 / 1024).toFixed(2)} MB)
                                                        {signedDocuments.tp && <span className="ml-2 text-purple-600 font-semibold">✓ SIGNED</span>}
                                                    </p>
                                                    {selectedDocuments.tp.type === 'application/pdf' && (
                                                        <div className="flex gap-1 mt-1">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setPdfForSigning(selectedDocuments.tp);
                                                                    setCurrentSigningAgency('tp');
                                                                    setShowSignaturePad(true);
                                                                }}
                                                                disabled={signedDocuments.tp !== null}
                                                                className={`px-2 py-1 text-xs rounded ${signedDocuments.tp
                                                                    ? 'bg-gray-400 text-white cursor-not-allowed'
                                                                    : 'bg-purple-600 text-white hover:bg-purple-700'
                                                                    }`}
                                                            >
                                                                {signedDocuments.tp ? 'Signed' : 'Sign'}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleViewDocument(signedDocuments.tp || selectedDocuments.tp)}
                                                                className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                                                            >
                                                                View
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].Remarks}</label>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        rows={2}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder={translations[language].EnterRemarks}
                                    />
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendToAgencyModal(false);
                                        setSelectedDocuments({ agriculture: null, forest: null, tp: null });
                                        setSignedDocuments({ agriculture: null, forest: null, tp: null });
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToAgency}
                                >
                                    {translations[language].Cancel}
                                </button>
                                <button
                                    onClick={handleSendToAgency}
                                    disabled={sendingToAgency || !hasValidSelection()}
                                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToAgency ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language].Sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language].CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Section 19 Modal */}
            {showSection19Modal && (
                <Section19
                    projectId={currentProjectId}
                    proposalId={proposalId}
                    onClose={() => setShowSection19Modal(false)}
                />
            )}

            {/* Simple Alert Notification */}
            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Simple Alert Notification */}
            {/* {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )} */}

            {/* Role-based Pre-Modal for DSLR / Surveyor */}
            {showRoleModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-4xl">
                        <h3 className="text-lg font-semibold mb-4">
                            {userRole === USER_ROLES.DSLR ? "भुकरमापक नेमणे (Assign to Surveyor)" : "उपअधीक्षक भूमी अभिलेख परत (Send Completed to DSLR)"}
                        </h3>

                        <div className="overflow-x-auto">
                            <table className="w-full border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border border-gray-300 px-4 py-2 text-left font-medium">{translations[language].landSerialNo}</th>
                                        <th className="border border-gray-300 px-4 py-2 text-center font-medium">{translations[language].Matter}</th>
                                        <th className="border border-gray-300 px-4 py-2 text-center font-medium">{translations[language].Remarks}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userRole === USER_ROLES.DSLR && (
                                        <>
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">1</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].AppointLandSurveyor} <span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <select
                                                        required
                                                        value={roleFormData.dlsr_appoint_surveyor || ""}
                                                        onChange={e => setRoleFormData({ ...roleFormData, dlsr_appoint_surveyor: e.target.value })}
                                                        disabled={loadingUsers}
                                                        className="w-full border p-2 rounded"
                                                    >
                                                        <option value=""> {translations[language].SelectUserSurveyor}</option>
                                                        {users.map((u) => (
                                                            <option key={u.id || u.usr_id} value={u.id || u.usr_id}>
                                                                {(u.full_name || u.user_name) + (u.usr_role ? ` (${u.usr_role})` : "")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">2</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center"> {translations[language].landAcquisitionAuthorityEcounting}<span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        type="date"
                                                        required
                                                        min="1990-01-01"
                                                        max="2050-12-31"
                                                        defaultValue={new Date().toISOString().split('T')[0]}
                                                        placeholder="भूसंपादन यंत्रणेने ई मोजणी प्रणालीत मोजणी अर्ज"
                                                        value={roleFormData.dlsr_survey_application_date || ""}
                                                        onChange={e => setRoleFormData({ ...roleFormData, dlsr_survey_application_date: e.target.value })}
                                                        className="w-full border p-2 rounded"
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">3</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].feeCollectedByLandAcquisition} <span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        type="number"
                                                        required
                                                        min="0"
                                                        step="0.01"
                                                        placeholder={translations[language].feeCollectedByLandAcquisition}
                                                        value={roleFormData.dlsr_gov_fee_paid_for_survey || ""}
                                                        onChange={e => setRoleFormData({ ...roleFormData, dlsr_gov_fee_paid_for_survey: e.target.value })}
                                                        className="w-full border p-2 rounded"
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">4</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].DatePaymentFeeCollected} <span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <div className="space-y-2">
                                                        <input
                                                            type="date"
                                                            required
                                                            min="1990-01-01"
                                                            max="2050-12-31"
                                                            defaultValue={new Date().toISOString().split('T')[0]}
                                                            placeholder={translations[language].DatePaymentFeeCollected}
                                                            value={roleFormData.dlsr_gov_fee_payment_date || ""}
                                                            onChange={e => setRoleFormData({ ...roleFormData, dlsr_gov_fee_payment_date: e.target.value })}
                                                            className="w-full border p-2 rounded"
                                                        />
                                                        <input
                                                            type="file"
                                                            required
                                                            accept=".pdf,.jpg,.jpeg,.png"
                                                            onChange={e => setRoleFile(e.target.files[0])}
                                                            className="w-full border p-2 rounded text-sm"
                                                        />
                                                        {proposalData?.dlsr_gov_fee_payment_img && (
                                                            <a
                                                                href={proposalData.dlsr_gov_fee_payment_img}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="block text-blue-600 underline text-sm"
                                                            >
                                                                View Uploaded File
                                                            </a>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )}

                                    {userRole === USER_ROLES.SURVEYOR && (
                                        <>
                                            {/* First column "1" will span all 3 rows */}
                                            <tr>
                                                <td
                                                    className="border border-gray-300 px-4 py-2 text-center align-top"
                                                    rowSpan={3}
                                                >
                                                    1
                                                </td>

                                                {/* "Joint Census Date" spans across the next 2 columns */}
                                                <td
                                                    className="border border-gray-300 px-4 py-2 text-center font-semibold"
                                                    colSpan={1}
                                                >
                                                    {translations[language].JointCensudDate}
                                                    <span className="text-red-600">*</span>
                                                </td>
                                            </tr>

                                            {/* Start Date Row */}
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    Start Date </td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        type="date"
                                                        required
                                                        min="1990-01-01"
                                                        max="2050-12-31"
                                                        value={
                                                            roleFormData.surveyor_joint_start_date ||
                                                            ""
                                                        }
                                                        onChange={e =>
                                                            setRoleFormData({
                                                                ...roleFormData,
                                                                surveyor_joint_start_date: e.target.value,
                                                            })
                                                        }
                                                        className="w-full border p-2 rounded"
                                                    />
                                                </td>
                                            </tr>

                                            {/* End Date Row */}
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    End Date
                                                </td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        type="date"
                                                        required
                                                        min="1990-01-01"
                                                        max="2050-12-31"
                                                        value={
                                                            roleFormData.surveyor_joint_end_date ||
                                                            " "
                                                        }
                                                        onChange={e =>
                                                            setRoleFormData({
                                                                ...roleFormData,
                                                                surveyor_joint_end_date: e.target.value,
                                                            })
                                                        }
                                                        className="w-full border p-2 rounded"
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">2</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].JointRepresentatives}<span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <select
                                                        required
                                                        value={roleFormData.surveyor_present_officials_name_designation || ""}
                                                        onChange={e => setRoleFormData({ ...roleFormData, surveyor_present_officials_name_designation: e.target.value })}
                                                        disabled={loadingUsers}
                                                        className="w-full border p-2 rounded"
                                                    >
                                                        <option value=""> {translations[language].SelectUserDSLR}</option>
                                                        {users.map((u) => (
                                                            <option key={u.id || u.usr_id} value={u.id || u.usr_id}>
                                                                {(u.full_name || u.user_name) + (u.usr_role ? ` (${u.usr_role})` : "")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">3</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].GeoTaggedPhoto} <span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        type="file"
                                                        required
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        onChange={e => setRoleFile(e.target.files[0])}
                                                        className="w-full border p-2 rounded text-sm"
                                                    />
                                                    {proposalData?.surveyor_geo_tagged_image && (
                                                        <a
                                                            href={proposalData.surveyor_geo_tagged_image}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="block text-blue-600 underline text-sm mt-2"
                                                        >
                                                            View Uploaded File
                                                        </a>
                                                    )}
                                                </td>
                                            </tr>
                                            {/* 4 */}
                                            <tr>
                                                <td className="border border-gray-300 px-4 py-2 text-center">4</td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].MRNo}<span className="text-red-600">*</span></td>
                                                <td className="border border-gray-300 px-4 py-2 text-center">
                                                    <input
                                                        required
                                                        value={roleFormData.surveyor_m_r_no || ""}
                                                        onChange={e => setRoleFormData({ ...roleFormData, surveyor_m_r_no: e.target.value })}
                                                        disabled={loadingUsers}
                                                        className="w-full border p-2 rounded"
                                                    >
                                                    </input>
                                                </td>
                                            </tr>

                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-6 flex justify-end gap-3">
                            <button onClick={() => setShowRoleModal(false)} className="px-4 py-2 bg-gray-200 rounded">
                                Cancel
                            </button>
                            <button
                                onClick={async () => {
                                    try {
                                        setSubmitting(true); // 🔹 disable + show loading
                                        const formData = new FormData();
                                        if (roleFile) {
                                            const fileFieldName =
                                                userRole === USER_ROLES.DSLR
                                                    ? "dlsr_gov_fee_payment_img"
                                                    : "surveyor_geo_tagged_image";
                                            formData.append(fileFieldName, roleFile);
                                        }
                                        // Role-based payload
                                        if (userRole === USER_ROLES.DSLR) {
                                            if (roleFormData.dlsr_appoint_surveyor)
                                                formData.append("dlsr_appoint_surveyor", roleFormData.dlsr_appoint_surveyor);
                                            if (roleFormData.dlsr_survey_application_date)
                                                formData.append("dlsr_survey_application_date", roleFormData.dlsr_survey_application_date);
                                            if (roleFormData.dlsr_gov_fee_paid_for_survey)
                                                formData.append("dlsr_gov_fee_paid_for_survey", roleFormData.dlsr_gov_fee_paid_for_survey);
                                            if (roleFormData.dlsr_gov_fee_payment_date)
                                                formData.append("dlsr_gov_fee_payment_date", roleFormData.dlsr_gov_fee_payment_date);
                                        }

                                        if (userRole === USER_ROLES.SURVEYOR) {
                                            if (!roleFormData.surveyor_joint_start_date || !roleFormData.surveyor_joint_end_date) {
                                                toast.error("Please select both start and end dates");
                                                return;
                                            }
                                            formData.set("surveyor_joint_start_date", roleFormData.surveyor_joint_start_date || "");
                                            formData.set("surveyor_joint_end_date", roleFormData.surveyor_joint_end_date || "");
                                            // if (roleFormData.surveyor_joint_start_date)
                                            //   formData.append("surveyor_joint_start_date", roleFormData.surveyor_joint_start_date);
                                            // if (roleFormData.surveyor_joint_end_date)
                                            //   formData.append("surveyor_joint_end_date", roleFormData.surveyor_joint_end_date);
                                            if (roleFormData.surveyor_present_officials_name_designation)
                                                formData.append("surveyor_present_officials_name_designation", roleFormData.surveyor_present_officials_name_designation);
                                            if (roleFormData.surveyor_m_r_no)
                                                formData.append("surveyor_m_r_no", roleFormData.surveyor_m_r_no);
                                            if (roleFormData.section_11_bhusampadan_no)
                                                formData.append("section_11_bhusampadan_no", roleFormData.section_11_bhusampadan_no);
                                            if (roleFormData.acquisition_agency)
                                                formData.append("acquisition_agency", roleFormData.acquisition_agency);
                                            if (roleFormData.acquisition_purpose)
                                                formData.append("acquisition_purpose", roleFormData.acquisition_purpose);
                                        }
                                        if (userRole === USER_ROLES.SURVEYOR) {
                                            // Check all required fields
                                            if (!roleFormData.surveyor_joint_start_date) {
                                                toast.error("Please select start date");
                                                return;
                                            }
                                            if (!roleFormData.surveyor_joint_end_date) {
                                                toast.error("Please select end date");
                                                return;
                                            }
                                            if (!roleFormData.surveyor_present_officials_name_designation) {
                                                toast.error("Please select joint representatives");
                                                return;
                                            }
                                            if (!roleFile) {
                                                toast.error("Please upload geo-tagged photo");
                                                return;
                                            }
                                            if (!roleFormData.surveyor_m_r_no) {
                                                toast.error("Please enter M.R. Number");
                                                return;
                                            }
                                        }

                                        if (userRole === USER_ROLES.DSLR) {
                                            // Check all required fields for DSLR
                                            if (!roleFormData.dlsr_appoint_surveyor) {
                                                toast.error("Please select surveyor");
                                                return;
                                            }
                                            if (!roleFormData.dlsr_survey_application_date) {
                                                toast.error("Please select survey application date");
                                                return;
                                            }
                                            if (!roleFormData.dlsr_gov_fee_paid_for_survey) {
                                                toast.error("Please enter government fee amount");
                                                return;
                                            }
                                            if (!roleFormData.dlsr_gov_fee_payment_date) {
                                                toast.error("Please select fee payment date");
                                                return;
                                            }
                                            if (!roleFile) {
                                                toast.error("Please upload fee payment document");
                                                return;
                                            }
                                        }
                                        const res = await apiService.updateRailwayProposalPublish(proposalId, formData);
                                        if (res.ok) {
                                            toast.success("Sent successfully!");
                                            setShowRoleModal(false);
                                            if (userRole === USER_ROLES.DSLR) {
                                                // Prefill the selected surveyor in the next modal
                                                setSelectedUser(roleFormData.dlsr_appoint_surveyor || "");
                                                setShowSendToSurveyorModal(true);
                                                await fetchUsers();
                                            }
                                            if (userRole === USER_ROLES.SURVEYOR) {
                                                // Prefill the selected DSLR official in the next modal  
                                                setSelectedUser(roleFormData.surveyor_present_officials_name_designation || "");
                                                setShowSendBackToDSLRModal(true);
                                                await fetchUsersSlr();
                                            }
                                        }
                                    } catch (err) {
                                        toast.error("Failed to save!");
                                        setSubmitting(false);

                                    } finally {
                                        setSubmitting(false);
                                    }
                                }}
                                disabled={submitting} // 🔹 disable while loading
                                className={`px-4 py-2 rounded text-white ${submitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600"
                                    }`}
                            >
                                {submitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Document Preview Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl p-4 w-full max-w-5xl h-[90vh] shadow-xl overflow-hidden">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="text-xl font-semibold text-gray-800">{translations[language].DocumentPreview}</h3>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    URL.revokeObjectURL(documentUrl);
                                }}
                                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>

                        {/* Document Viewer */}
                        <iframe
                            src={documentUrl}
                            className="w-full h-[80vh] rounded border border-gray-300"
                            title="Document Preview"
                        />
                    </div>
                </div>
            )}

            {/* Simple Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language].Cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language].Confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Simple Confirmation Modal */}
            {/* {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}

            {/* Confirmation Modal */}
            {/* {showConfirmationModal && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                        <div className="flex items-center mb-4">
                            <div className="bg-red-100 p-2 rounded-full mr-3">
                                <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800">{translations[language].ProceedConfirmation}</h3>
                        </div>
                        <p className="text-sm text-gray-600 mb-6">
                            {translations[language].ProceedNote}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                                onClick={() => setShowConfirmationModal(false)}
                            >
                                {translations[language].No}
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                onClick={() => {
                                    setShowConfirmationModal(false);
                                    if (onConfirmAction) onConfirmAction();
                                }}
                            >
                                {translations[language].YesContinue}
                            </button>
                        </div>
                    </div>
                </div>
            )} */}

            {/* Success/Error Messages */}
            {message && (
                <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${message.includes('Error') || message.includes('failed')
                    ? 'bg-red-100 border border-red-400 text-red-700'
                    : 'bg-green-100 border border-green-400 text-green-700'
                    }`}>
                    <div className="flex items-center gap-2">
                        {message.includes('Error') || message.includes('failed') ? (
                            <X className="w-5 h-5" />
                        ) : (
                            <Check className="w-5 h-5" />
                        )}
                        <span>{message}</span>
                    </div>
                </div>
            )}

            {showLandSelectionModal && <LandSelectionModal />}

            {showAddOwner && (
                <AddOwner
                    onBack={() => setShowAddOwner(false)}
                    newOwner={newOwner}
                    setNewOwner={setNewOwner}
                    onAdd={handleAddOwner}
                    onCancel={handleCancel}
                    onRefresh={fetchMeasurementData}
                    landAcquisition={selectedLandRecord}  // THIS IS THE NEW LINE
                    isOpen={showAddOwner}
                    onClose={() => setShowAddOwner(false)}
                />
            )}

            {/* EditOwner Modal */}
            {showEditOwner && (
                <EditOwner
                    editFormData={editFormData}
                    setEditFormData={setEditFormData}
                    onCancel={handleCancelEdit}
                    onRefresh={fetchMeasurementData}
                    landAcquisition={landAcquisitionData?.[0]}
                    isOpen={showEditOwner}
                    owner={selectedOwnerInDetails}
                    onClose={() => setShowEditOwner(false)}
                    prefillData={selectedOwnerInDetails}
                />
            )}
        </div>
    );
};


export default RailwayJointMesurmentList;